import * as React from "react";
import { createContext, useContext, useState, useLayoutEffect, useMemo, useEffect, forwardRef, createRef, useRef, useCallback } from "react";
import { jsx, jsxs, Fragment } from "react/jsx-runtime";
import { Skeleton as Skeleton$1, Box, InputAdornment, InputLabel, FormHelperText, OutlinedInput, IconButton, useMediaQuery, useScrollTrigger, AppBar, Drawer, Divider, Toolbar, Typography, Slide } from "@mui/material";
import { BREAKPOINT_DIMENSIONS, useMediaQuery as useMediaQuery$1, DesignSystemProvider, APP_NAMES } from "@quickenloans-ui-suite/design-system";
import { styled } from "@mui/material/styles";
import { styled as styled$1 } from "@mui/system";
import { ChevronRight, Search, Close, NavigateBefore, LogoutOutlined, KeyboardArrowUpOutlined, KeyboardArrowDownOutlined } from "@mui/icons-material";
import { BYOButton, Button, Headline5 } from "@cdm/quickenloans-library/lib/";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import ErrorIcon from "@mui/icons-material/Error";
import { c as classes, a as components } from "../components-KTeluIza.js";
const LABELS = {
  GET_STARTED: "Get Started",
  MY_ACCOUNT: "My Account",
  SIGN_IN_JOIN: "Sign In / Join",
  SEARCH: "Search",
  SEARCH_PLACEHOLDER: "What can we help you find?"
};
const ARIA_LABELS = {
  GET_STARTED: "Get started",
  MY_ACCOUNT: "My account",
  SIGN_IN_JOIN: "Sign in or join",
  NAVIGATION_MENU: "Navigation menu button",
  LOGO: "Quicken Loans logo",
  SEARCH_ICON: "Search"
};
const SOURCE_KEY = "sourceid";
const SOURCE_PREFIX = "qlwebsite_";
const COOKIE_EXPIRATION_DAYS = 365;
const COOKIE_EXPIRATION_TIME = COOKIE_EXPIRATION_DAYS * 24 * 60 * 60 * 1e3;
const fallbackGlobalObject = {
  globalNav: {
    nodes: [
      {
        databaseId: 8830,
        label: "Learning Center",
        path: "#",
        url: "#",
        parentDatabaseId: 0,
        childItems: {
          nodes: [
            {
              databaseId: 9561,
              label: "All Topics",
              path: "/learn",
              url: "https://www.quickenloans.com/learn",
              parentDatabaseId: 8830
            },
            {
              databaseId: 8833,
              label: "Home Buying",
              path: "/learn/home-buying",
              url: "https://www.quickenloans.com/learn/home-buying",
              parentDatabaseId: 8830
            },
            {
              databaseId: 8831,
              label: "Mortgages",
              path: "/learn/mortgages",
              url: "https://www.quickenloans.com/learn/mortgages",
              parentDatabaseId: 8830
            },
            {
              databaseId: 8835,
              label: "Loans",
              path: "/learn/loans",
              url: "https://www.quickenloans.com/learn/loans",
              parentDatabaseId: 8830
            },
            {
              databaseId: 8837,
              label: "Refinancing",
              path: "/learn/refinancing",
              url: "https://www.quickenloans.com/learn/refinancing",
              parentDatabaseId: 8830
            },
            {
              databaseId: 8839,
              label: "Home Selling",
              path: "/learn/home-selling",
              url: "https://www.quickenloans.com/learn/home-selling",
              parentDatabaseId: 8830
            },
            {
              databaseId: 8840,
              label: "Real Estate",
              path: "/learn/real-estate",
              url: "https://www.quickenloans.com/learn/real-estate",
              parentDatabaseId: 8830
            }
          ]
        }
      },
      {
        databaseId: 8841,
        label: "Refinance",
        path: "#",
        url: "#",
        parentDatabaseId: 0,
        childItems: {
          nodes: [
            {
              databaseId: 8842,
              label: "Refinance Guide",
              path: "/learn/what-is-refinancing",
              url: "https://www.quickenloans.com/learn/what-is-refinancing",
              parentDatabaseId: 8841
            },
            {
              databaseId: 8843,
              label: "Lower Your Payment",
              path: "/learn/how-to-lower-monthly-mortgage-payment",
              url: "https://www.quickenloans.com/learn/how-to-lower-monthly-mortgage-payment",
              parentDatabaseId: 8841
            },
            {
              databaseId: 9541,
              label: "Pay Off Your Mortgage Faster",
              path: "/learn/paying-off-mortgage",
              url: "https://www.quickenloans.com/learn/paying-off-mortgage",
              parentDatabaseId: 8841
            },
            {
              databaseId: 9540,
              label: "Reasons To Refinance",
              path: "/learn/reasons-to-refinance-your-home",
              url: "https://www.quickenloans.com/learn/reasons-to-refinance-your-home",
              parentDatabaseId: 8841
            },
            {
              databaseId: 9539,
              label: "Consolidate Your Debt",
              path: "/learn/what-is-debt-consolidation",
              url: "https://www.quickenloans.com/learn/what-is-debt-consolidation",
              parentDatabaseId: 8841
            },
            {
              databaseId: 9538,
              label: "Get Cash From Your Home",
              path: "/learn/cash-out-refinance",
              url: "https://www.quickenloans.com/learn/cash-out-refinance",
              parentDatabaseId: 8841
            },
            {
              databaseId: 9537,
              label: "Refinance Your Property",
              path: "/learn/refinance-investment-property",
              url: "https://www.quickenloans.com/learn/refinance-investment-property",
              parentDatabaseId: 8841
            }
          ]
        }
      },
      {
        databaseId: 8844,
        label: "Buy A Home",
        path: "#",
        url: "#",
        parentDatabaseId: 0,
        childItems: {
          nodes: [
            {
              databaseId: 8845,
              label: "Home Buyer’s Guide",
              path: "/learn/should-i-buy-a-house",
              url: "https://www.quickenloans.com/learn/should-i-buy-a-house",
              parentDatabaseId: 8844
            },
            {
              databaseId: 9542,
              label: "First-time Homebuyer",
              path: "/learn/steps-to-buying-a-house",
              url: "https://www.quickenloans.com/learn/steps-to-buying-a-house",
              parentDatabaseId: 8844
            },
            {
              databaseId: 9543,
              label: "Buying a Vacation Home",
              path: "/learn/how-to-buy-a-vacation-home",
              url: "https://www.quickenloans.com/learn/how-to-buy-a-vacation-home",
              parentDatabaseId: 8844
            },
            {
              databaseId: 9544,
              label: "Relocation",
              path: "/learn/moving-to-another-state",
              url: "https://www.quickenloans.com/learn/moving-to-another-state",
              parentDatabaseId: 8844
            },
            {
              databaseId: 9545,
              label: "Real Estate Investors",
              path: "/learn/investment-property",
              url: "https://www.quickenloans.com/learn/investment-property",
              parentDatabaseId: 8844
            }
          ]
        }
      },
      {
        databaseId: 9546,
        label: "Loan Options",
        path: "#",
        url: "#",
        parentDatabaseId: 0,
        childItems: {
          nodes: [
            {
              databaseId: 9547,
              label: "Compare All Loan Options",
              path: "/home-loans",
              url: "https://www.quickenloans.com/home-loans",
              parentDatabaseId: 9546
            },
            {
              databaseId: 9548,
              label: "Adjustable Rate Mortgage",
              path: "/home-loans/adjustable-rate-mortgage",
              url: "https://www.quickenloans.com/home-loans/adjustable-rate-mortgage",
              parentDatabaseId: 9546
            },
            {
              databaseId: 9549,
              label: "30-Year Fixed Mortgage",
              path: "/home-loans/30-year-fixed",
              url: "https://www.quickenloans.com/home-loans/30-year-fixed",
              parentDatabaseId: 9546
            },
            {
              databaseId: 9550,
              label: "15-Year Fixed Mortgages",
              path: "/home-loans/15-year-fixed",
              url: "https://www.quickenloans.com/home-loans/15-year-fixed",
              parentDatabaseId: 9546
            },
            {
              databaseId: 9551,
              label: "FHA Loans",
              path: "/home-loans/fha-loan",
              url: "https://www.quickenloans.com/home-loans/fha-loan",
              parentDatabaseId: 9546
            },
            {
              databaseId: 9552,
              label: "FHA Streamline",
              path: "/home-loans/fha-streamline",
              url: "https://www.quickenloans.com/home-loans/fha-streamline",
              parentDatabaseId: 9546
            },
            {
              databaseId: 9553,
              label: "VA Loans",
              path: "/home-loans/va-loan",
              url: "https://www.quickenloans.com/home-loans/va-loan",
              parentDatabaseId: 9546
            },
            {
              databaseId: 9554,
              label: "USDA Loan",
              path: "/learn/benefits-usda-loans",
              url: "https://www.quickenloans.com/learn/benefits-usda-loans",
              parentDatabaseId: 9546
            },
            {
              databaseId: 9555,
              label: "Jumbo Loans",
              path: "/home-loans/jumbo-mortgage",
              url: "https://www.quickenloans.com/home-loans/jumbo-mortgage",
              parentDatabaseId: 9546
            },
            {
              databaseId: 9556,
              label: "Custom Term Loan",
              path: "/home-loans/custom-mortgage-yourgage",
              url: "https://www.quickenloans.com/home-loans/custom-mortgage-yourgage",
              parentDatabaseId: 9546
            }
          ]
        }
      },
      {
        databaseId: 8873,
        label: "Mortgage Rates",
        path: "/mortgage-rates",
        url: "https://www.quickenloans.com/mortgage-rates",
        parentDatabaseId: 0,
        childItems: {
          nodes: []
        }
      },
      {
        databaseId: 9557,
        label: "Calculators",
        path: "#",
        url: "#",
        parentDatabaseId: 0,
        childItems: {
          nodes: [
            {
              databaseId: 9558,
              label: "All Calculators",
              path: "/calculators",
              url: "https://www.quickenloans.com/calculators",
              parentDatabaseId: 9557
            },
            {
              databaseId: 9562,
              label: "Refinance Calculator",
              path: "/calculators/refinance-calculator",
              url: "https://www.quickenloans.com/calculators/refinance-calculator",
              parentDatabaseId: 9557
            },
            {
              databaseId: 9560,
              label: "Purchase Mortgage Calculator",
              path: "/calculators/mortgage-calculator",
              url: "https://www.quickenloans.com/calculators/mortgage-calculator",
              parentDatabaseId: 9557
            },
            {
              databaseId: 9563,
              label: "Rent vs. Buy Calculator",
              path: "/calculators/rent-vs-buy-calculator",
              url: "https://www.quickenloans.com/calculators/rent-vs-buy-calculator",
              parentDatabaseId: 9557
            },
            {
              databaseId: 9559,
              label: "Home Affordability Calculator",
              path: "/calculators/home-affordability-calculator",
              url: "https://www.quickenloans.com/calculators/home-affordability-calculator",
              parentDatabaseId: 9557
            },
            {
              databaseId: 9564,
              label: "Amortization Calculator",
              path: "/calculators/amortization-calculator",
              url: "https://www.quickenloans.com/calculators/amortization-calculator",
              parentDatabaseId: 9557
            }
          ]
        }
      }
    ]
  },
  globalAccount: {
    nodes: [
      {
        databaseId: 8859,
        label: "My Dashboard",
        path: "https://accounts.quickenloans.com/",
        url: "https://accounts.quickenloans.com/",
        parentDatabaseId: 0,
        childItems: {
          nodes: []
        }
      },
      {
        databaseId: 8860,
        label: "Home Buying Guide",
        path: "https://accounts.quickenloans.com/milestone",
        url: "https://accounts.quickenloans.com/milestone",
        parentDatabaseId: 0,
        childItems: {
          nodes: []
        }
      },
      {
        databaseId: 8861,
        label: "Favorites",
        path: "https://accounts.quickenloans.com/favorites",
        url: "https://accounts.quickenloans.com/favorites",
        parentDatabaseId: 0,
        childItems: {
          nodes: []
        }
      },
      {
        databaseId: 8862,
        label: "Perks",
        path: "https://accounts.quickenloans.com/perks",
        url: "https://accounts.quickenloans.com/perks",
        parentDatabaseId: 0,
        childItems: {
          nodes: []
        }
      },
      {
        databaseId: 8863,
        label: "Profile",
        path: "https://accounts.quickenloans.com/profile",
        url: "https://accounts.quickenloans.com/profile",
        parentDatabaseId: 0,
        childItems: {
          nodes: []
        }
      },
      {
        databaseId: 8864,
        label: "Settings",
        path: "https://accounts.quickenloans.com/settings",
        url: "https://accounts.quickenloans.com/settings",
        parentDatabaseId: 0,
        childItems: {
          nodes: []
        }
      },
      {
        databaseId: 8865,
        label: "Sign Out",
        path: "https://accounts.quickenloans.com/api/auth/logout",
        url: "https://accounts.quickenloans.com/api/auth/logout",
        parentDatabaseId: 0,
        childItems: {
          nodes: []
        }
      }
    ]
  }
};
const CRITERIA_TYPE = "credit-score";
const OFFER_CTA_PREFIX = "On";
const HOST_PLATFORM = {
  GATSBY: "gatsby",
  NEXT: "next"
};
const LINK_TYPES = {
  GATSBY: "to",
  NEXT: "href"
};
const HYBRID_BREAKPOINTS = {
  MIN_WIDTH: 1200,
  MAX_WIDTH: 1439
};
const DRAWER_TRANSITION_DURATION = 400;
const DRAWER_TRANSITION_DURATION_DESKTOP = {
  enter: 300,
  exit: 300
};
const SKELETON_VARIANTS = {
  TEXT: "text",
  CIRCULAR: "circular",
  RECTANGULAR: "rectangular",
  ROUNDED: "rounded",
  ROUNDED_RECT: "rounded-rect"
};
const NAVIGATION_BAR_ACTIONS = {
  TIER_1: "TIER_1",
  TIER_2: "TIER_2",
  SEARCH_BAR: "SEARCH_BAR",
  CLOSE_ALL: "CLOSE_ALL"
};
const USER_SESSION_COOKIE = "userSession";
const logoLarge = "data:image/svg+xml,%3csvg%20width='863'%20height='105'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M856.565%2024.251c.981%200%202.337.187%202.337-1.059%200-.9-.785-1.023-1.668-1.023h-1.829v2.082h1.16zm3.301%204.088h-1.206l-2.015-3.21h-1.235v3.21h-1.044v-6.965h3.076c.6%200%201.183.035%201.726.333.519.304.779.918.779%201.497%200%201.38-.97%201.877-2.228%201.924l2.147%203.21zm-8.271-3.52c0%202.841%202.263%205.04%205.114%205.04s5.102-2.199%205.102-5.04c0-2.843-2.274-4.96-5.102-4.96-2.828%200-5.114%202.217-5.114%204.96zm-1.212%200c0-3.392%202.834-6.17%206.32-6.17S863%2021.42%20863%2024.819c0%203.397-2.811%206.262-6.297%206.262-3.486%200-6.32-2.79-6.32-6.263zM798.24%2068.172c.189%206.275%207.201%207.038%2012.795%207.038%202.587%200%209.936-.257%2010.692-4.092.667-3.336-8.064-3.959-10.361-4.238-13.545-1.91-29.536-4.598-26.098-22.008%201.465-7.433%206.663-13.312%2013.669-17.148%207.266-3.964%2014.904-4.988%2022.311-4.988%2012.506%200%2024.716%204.738%2026.712%2017.014l-20.391%203.725c-1.058-4.494-5.884-5.774-10.444-5.774-2.085%200-8.447.64-9.008%203.446-.402%202.06%201.624%202.95%203.249%203.335%202.711.768%207.844%201.152%2010.886%201.542%205.831.769%2012.435%201.66%2017.131%204.86%205.352%203.83%207.473%209.605%206.09%2016.642-3.579%2018.097-23.977%2023.23-38.939%2023.23-14.963%200-27.557-4.755-29.518-19.918l21.224-2.671v.005zM743.18%2024.203l-1.837%209.33h.254c4.566-7.45%2012.812-10.553%2020.875-10.553%206.268%200%2013.055%201.81%2016.009%206.752%203.113%205.408%201.636%2012.864.301%2019.651l-7.969%2040.384h-25.808l7.833-39.744c.774-3.975%201.872-9.482-3.71-9.482-7.112%200-8.955%206.025-10.007%2011.38l-7.454%2037.846h-25.814l12.93-65.564h24.397zM698.9%2089.424c-1.04-4.645-.207-9.511.75-14.383l4.519-22.91c1.837-9.355%204.56-17.8-2.989-23.842-5.606-4.616-15.43-5.646-23.263-5.646-14.968%200-31.579%204.237-38.697%2020.53l23.274%202.17c1.873-5.512%206.516-7.31%2011.602-7.31%206.261%200%207.36%202.316%206.208%208.201l-.106.506c-8.826.524-18.023%201.549-26.996%204.11-9.818%202.817-19.381%209.726-21.419%2020.105-2.534%2012.997%206.964%2019.709%2019.334%2019.709%209.126%200%2017.119-2.858%2023.817-10.42-.614%203.126-.957%206.211-.892%209.18H698.9zm-21.307-29.459c-1.406%207.2-3.149%2015.285-12.913%2015.285-4.047%200-6.421-1.793-5.594-6.03%201.583-7.957%2012.375-9.89%2018.761-10.535l-.26%201.274.006.006zM602.531%2022.62c-20.841%200-39.259%2013.62-43.4%2034.574-3.905%2019.843%209.658%2033.464%2029.967%2033.464%2020.309%200%2039.259-13.62%2043.169-33.464%204.141-20.954-8.914-34.575-29.736-34.575zm-3.172%2016.047c8.866%200%206.757%2011.385%205.523%2017.637-3.45%2017.52-8.016%2018.79-12.7%2018.79-4.685%200-8.761-1.27-5.305-18.79%201.24-6.246%203.609-17.637%2012.482-17.637zM551.747%2089.424h-62.61l17.367-88.08h27.569l-13.126%2066.497h35.059l-4.259%2021.583zM437.68%2023.813l-1.784%209.086h.26c4.59-7.41%2012.884-10.414%2020.947-10.414%206.22%200%2013.007%201.747%2015.89%206.857%203.084%205.385%201.619%2012.812.278%2019.57l-7.916%2040.145h-25.661l7.786-39.494c.774-3.975%201.861-9.452-3.692-9.452-7.142%200-8.967%206-10.007%2011.269l-7.425%2037.677H400.66l12.884-65.239h24.13l.006-.005zM374.764%2065.64c-2.145%205.64-5.843%207.945-11.673%207.945-7.791%200-9.375-5.122-7.596-12.17h44.356l.685-3.452c4.218-21.409-6.492-35.466-28.543-35.466-9.475%200-20.22%203.196-28.325%2010.093-7.46%206.252-12.83%2015.786-14.59%2024.61-1.831%209.343.159%2018.312%206.055%2024.581%206.22%206.537%2015.287%208.586%2025.022%208.586%2015.701%200%2031.414-7.294%2038.568-23.178l-23.965-1.543.006-.006zm-16.871-17.008c.915-5.972%204.666-11.181%2011.412-11.181%207.272%200%208.394%204.83%207.136%2011.181h-18.548z'%20fill='%23B42325'/%3e%3cpath%20d='m314.286%2046.263%2013.87%2042.788h-26.848l-7.307-26.158-8.092%208.178-3.551%2017.98h-25.66l17.296-87.706h25.672l-9.345%2047.345%207.012-7.287%2019.039-17.59h22.317l-24.403%2022.45zM256.296%2064.494c-5.671%2016.909-19.635%2025.867-36.506%2025.867-9.588%200-16.93-2.171-22.589-8.958-5.417-6.677-6.799-15.495-4.95-24.82%203.887-19.68%2020.462-34.103%2040.812-34.103%2016.345%200%2027.445%209.44%2026.169%2025.785l-23.079%201.921v-.657c-.036-4.465-.054-9.57-5.766-9.57-8.175%200-10.266%2010.611-11.395%2016.362-1.217%206.13-3.054%2016.1%205.376%2016.1%205.582%200%208.648-4.988%2010.213-9.714l21.709%201.787h.006zM194.749%2017.317h-25.666L172.497%200h25.672l-3.414%2017.317h-.006zM180.613%2089.05h-25.684l12.872-65.238h25.666L180.613%2089.05zM123.574%2089.051l2.091-10.628h-.254c-4.365%208.428-13.811%2011.955-22.346%2011.955-5.447%200-10.521-1.234-13.8-4.976-3.756-4.61-3.142-10.355-1.931-16.508l8.896-45.087h25.667l-7.78%2039.464c-.821%204.22-1.855%208.702%203.975%208.702%202.576%200%205.305-1.42%206.918-3.713%201.595-2.177%202.173-4.47%202.646-6.91l7.408-37.543h25.666l-12.854%2065.238h-24.308l.006.006zM1.09%2045.559C-3.59%2069.26%206.778%2090.36%2032.587%2090.36c3.869%200%207.708-.384%2011.66-1.409C44.761%20100.763%2051.058%20105%2063.091%20105l10.869-.646%203.946-19.971c-2.457.629-4.868%201.013-7.325%201.013-3.243%200-7.78-.635-7.673-4.476%2013.12-7.422%2020.716-22.241%2023.286-35.297C91.292%2019.813%2080.298%200%2052.836%200c-12.972%200-24.06%203.586-34.58%2013.556C8.905%2022.376%203.364%2034.04%201.09%2045.56zm38.142%2024.866c-13.852%200-10.225-15.763-8.3-25.489%201.867-9.488%204.56-25.116%2017.9-25.116%206.603%200%209.049%203.97%209.474%209.743.26%205.233-.768%2012.428-1.807%2017.684-1.82%209.214-4.708%2023.184-17.261%2023.184'%20fill='%23B42325'/%3e%3c/svg%3e";
const logoSmall = "data:image/svg+xml,%3csvg%20width='39'%20height='25'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M.268%2010.751c-1.15%205.593%201.398%2010.572%207.741%2010.572.951%200%201.895-.09%202.866-.332.127%202.787%201.674%203.787%204.632%203.787l2.671-.153.97-4.712a7.505%207.505%200%200%201-1.8.239c-.797%200-1.912-.15-1.886-1.057%203.224-1.75%205.091-5.248%205.723-8.329C22.438%204.676%2019.736%200%2012.986%200%209.798%200%207.073.846%204.487%203.199%202.189%205.28.827%208.033.267%2010.751zm9.375%205.868c-3.405%200-2.514-3.72-2.04-6.015.458-2.239%201.12-5.927%204.399-5.927%201.623%200%202.224.937%202.329%202.3.064%201.234-.189%202.932-.445%204.172-.447%202.175-1.157%205.471-4.242%205.471M37.61%2021.102H22.222L26.49.317h6.776L30.04%2016.01h8.617l-1.047%205.093z'%20fill='%23B42325'/%3e%3c/svg%3e";
const AppContextDefaults = {
  isAuthenticated: false,
  isDesktop: false,
  isSearchBarOpen: false,
  isTierOneNavOpen: false,
  isTierTwoNavOpen: false,
  isMyAccountMenuOpen: false,
  menuData: {
    globalNav: fallbackGlobalObject.globalNav.nodes,
    globalAccount: fallbackGlobalObject.globalAccount.nodes
  }
};
const GlobalHeadContext = createContext(AppContextDefaults);
const production = {
  APP_BASE_URL: "https://www.quickenloans.com",
  AUTH0_LOGIN_URL: "https://accounts.quickenloans.com/login",
  BFF_API_URL: "https://www.quickenloans.com/api",
  COOKIE_DOMAIN: ".quickenloans.com",
  NODE_ENV: "production",
  BFF_API_USER_DATA_URL: "https://www.quickenloans.com/api/user/v1/user-data",
  REFINANCE_BASE_URL: "https://refinance.quickenloans.com",
  GET_OFFERS_API: "https://marketing.lowermybills.com/api/click-offer/offers/v1"
};
const qa = {
  APP_BASE_URL: "https://qa.quickenloans.com",
  AUTH0_LOGIN_URL: "https://qa.accounts.quickenloans.com/login",
  BFF_API_URL: "https://shared-bff.qa.quickenloans.com/api",
  COOKIE_DOMAIN: ".quickenloans.com",
  NODE_ENV: "qa",
  BFF_API_USER_DATA_URL: "https://shared-bff.qa.quickenloans.com/api/user/v1/user-data",
  REFINANCE_BASE_URL: "https://qa.refinance.quickenloans.com",
  GET_OFFERS_API: "https://qa.lowermybills.com/api/click-offer/offers/v1"
};
const development = {
  APP_BASE_URL: "https://qa.quickenloans.com",
  AUTH0_LOGIN_URL: "https://qa.accounts.quickenloans.com/login",
  BFF_API_URL: "https://shared-bff.qa.quickenloans.com/api",
  COOKIE_DOMAIN: ".quickenloans.com",
  NODE_ENV: "development",
  BFF_API_USER_DATA_URL: "https://shared-bff.qa.quickenloans.com/api/user/v1/user-data",
  REFINANCE_BASE_URL: "https://qa.refinance.quickenloans.com",
  GET_OFFERS_API: "https://qa.lowermybills.com/api/click-offer/offers/v1"
};
const environments = {
  production,
  qa,
  development
};
const getEnvVariable = ({ currentEnv, keyToSearch, defaultValue = void 0 }) => {
  try {
    if (!currentEnv) {
      return defaultValue;
    }
    const config = environments[currentEnv];
    return (config == null ? void 0 : config[keyToSearch]) ?? defaultValue;
  } catch (error) {
    console.error("Something went wrong getting the environment variable", { keyToSearch, error });
    return defaultValue;
  }
};
var cookie = {};
/*!
 * cookie
 * Copyright(c) 2012-2014 Roman Shtylman
 * Copyright(c) 2015 Douglas Christopher Wilson
 * MIT Licensed
 */
var hasRequiredCookie;
function requireCookie() {
  if (hasRequiredCookie) return cookie;
  hasRequiredCookie = 1;
  cookie.parse = parse;
  cookie.serialize = serialize;
  var __toString = Object.prototype.toString;
  var __hasOwnProperty = Object.prototype.hasOwnProperty;
  var cookieNameRegExp = /^[!#$%&'*+\-.^_`|~0-9A-Za-z]+$/;
  var cookieValueRegExp = /^("?)[\u0021\u0023-\u002B\u002D-\u003A\u003C-\u005B\u005D-\u007E]*\1$/;
  var domainValueRegExp = /^([.]?[a-z0-9]([a-z0-9-]{0,61}[a-z0-9])?)([.][a-z0-9]([a-z0-9-]{0,61}[a-z0-9])?)*$/i;
  var pathValueRegExp = /^[\u0020-\u003A\u003D-\u007E]*$/;
  function parse(str, opt) {
    if (typeof str !== "string") {
      throw new TypeError("argument str must be a string");
    }
    var obj = {};
    var len = str.length;
    if (len < 2) return obj;
    var dec = opt && opt.decode || decode;
    var index = 0;
    var eqIdx = 0;
    var endIdx = 0;
    do {
      eqIdx = str.indexOf("=", index);
      if (eqIdx === -1) break;
      endIdx = str.indexOf(";", index);
      if (endIdx === -1) {
        endIdx = len;
      } else if (eqIdx > endIdx) {
        index = str.lastIndexOf(";", eqIdx - 1) + 1;
        continue;
      }
      var keyStartIdx = startIndex(str, index, eqIdx);
      var keyEndIdx = endIndex(str, eqIdx, keyStartIdx);
      var key = str.slice(keyStartIdx, keyEndIdx);
      if (!__hasOwnProperty.call(obj, key)) {
        var valStartIdx = startIndex(str, eqIdx + 1, endIdx);
        var valEndIdx = endIndex(str, endIdx, valStartIdx);
        if (str.charCodeAt(valStartIdx) === 34 && str.charCodeAt(valEndIdx - 1) === 34) {
          valStartIdx++;
          valEndIdx--;
        }
        var val = str.slice(valStartIdx, valEndIdx);
        obj[key] = tryDecode(val, dec);
      }
      index = endIdx + 1;
    } while (index < len);
    return obj;
  }
  function startIndex(str, index, max) {
    do {
      var code = str.charCodeAt(index);
      if (code !== 32 && code !== 9) return index;
    } while (++index < max);
    return max;
  }
  function endIndex(str, index, min) {
    while (index > min) {
      var code = str.charCodeAt(--index);
      if (code !== 32 && code !== 9) return index + 1;
    }
    return min;
  }
  function serialize(name, val, opt) {
    var enc = opt && opt.encode || encodeURIComponent;
    if (typeof enc !== "function") {
      throw new TypeError("option encode is invalid");
    }
    if (!cookieNameRegExp.test(name)) {
      throw new TypeError("argument name is invalid");
    }
    var value = enc(val);
    if (!cookieValueRegExp.test(value)) {
      throw new TypeError("argument val is invalid");
    }
    var str = name + "=" + value;
    if (!opt) return str;
    if (null != opt.maxAge) {
      var maxAge = Math.floor(opt.maxAge);
      if (!isFinite(maxAge)) {
        throw new TypeError("option maxAge is invalid");
      }
      str += "; Max-Age=" + maxAge;
    }
    if (opt.domain) {
      if (!domainValueRegExp.test(opt.domain)) {
        throw new TypeError("option domain is invalid");
      }
      str += "; Domain=" + opt.domain;
    }
    if (opt.path) {
      if (!pathValueRegExp.test(opt.path)) {
        throw new TypeError("option path is invalid");
      }
      str += "; Path=" + opt.path;
    }
    if (opt.expires) {
      var expires = opt.expires;
      if (!isDate(expires) || isNaN(expires.valueOf())) {
        throw new TypeError("option expires is invalid");
      }
      str += "; Expires=" + expires.toUTCString();
    }
    if (opt.httpOnly) {
      str += "; HttpOnly";
    }
    if (opt.secure) {
      str += "; Secure";
    }
    if (opt.partitioned) {
      str += "; Partitioned";
    }
    if (opt.priority) {
      var priority = typeof opt.priority === "string" ? opt.priority.toLowerCase() : opt.priority;
      switch (priority) {
        case "low":
          str += "; Priority=Low";
          break;
        case "medium":
          str += "; Priority=Medium";
          break;
        case "high":
          str += "; Priority=High";
          break;
        default:
          throw new TypeError("option priority is invalid");
      }
    }
    if (opt.sameSite) {
      var sameSite = typeof opt.sameSite === "string" ? opt.sameSite.toLowerCase() : opt.sameSite;
      switch (sameSite) {
        case true:
          str += "; SameSite=Strict";
          break;
        case "lax":
          str += "; SameSite=Lax";
          break;
        case "strict":
          str += "; SameSite=Strict";
          break;
        case "none":
          str += "; SameSite=None";
          break;
        default:
          throw new TypeError("option sameSite is invalid");
      }
    }
    return str;
  }
  function decode(str) {
    return str.indexOf("%") !== -1 ? decodeURIComponent(str) : str;
  }
  function isDate(val) {
    return __toString.call(val) === "[object Date]";
  }
  function tryDecode(str, decode2) {
    try {
      return decode2(str);
    } catch (e) {
      return str;
    }
  }
  return cookie;
}
var cookieExports = requireCookie();
function hasDocumentCookie() {
  const testingValue = typeof global === "undefined" ? void 0 : global.TEST_HAS_DOCUMENT_COOKIE;
  if (typeof testingValue === "boolean") {
    return testingValue;
  }
  return typeof document === "object" && typeof document.cookie === "string";
}
function parseCookies(cookies) {
  if (typeof cookies === "string") {
    return cookieExports.parse(cookies);
  } else if (typeof cookies === "object" && cookies !== null) {
    return cookies;
  } else {
    return {};
  }
}
function readCookie(value, options = {}) {
  const cleanValue = cleanupCookieValue(value);
  if (!options.doNotParse) {
    try {
      return JSON.parse(cleanValue);
    } catch (e) {
    }
  }
  return value;
}
function cleanupCookieValue(value) {
  if (value && value[0] === "j" && value[1] === ":") {
    return value.substr(2);
  }
  return value;
}
class Cookies {
  constructor(cookies, defaultSetOptions = {}) {
    this.changeListeners = [];
    this.HAS_DOCUMENT_COOKIE = false;
    this.update = () => {
      if (!this.HAS_DOCUMENT_COOKIE) {
        return;
      }
      const previousCookies = this.cookies;
      this.cookies = cookieExports.parse(document.cookie);
      this._checkChanges(previousCookies);
    };
    const domCookies = typeof document === "undefined" ? "" : document.cookie;
    this.cookies = parseCookies(cookies || domCookies);
    this.defaultSetOptions = defaultSetOptions;
    this.HAS_DOCUMENT_COOKIE = hasDocumentCookie();
  }
  _emitChange(params) {
    for (let i = 0; i < this.changeListeners.length; ++i) {
      this.changeListeners[i](params);
    }
  }
  _checkChanges(previousCookies) {
    const names = new Set(Object.keys(previousCookies).concat(Object.keys(this.cookies)));
    names.forEach((name) => {
      if (previousCookies[name] !== this.cookies[name]) {
        this._emitChange({
          name,
          value: readCookie(this.cookies[name])
        });
      }
    });
  }
  _startPolling() {
    this.pollingInterval = setInterval(this.update, 300);
  }
  _stopPolling() {
    if (this.pollingInterval) {
      clearInterval(this.pollingInterval);
    }
  }
  get(name, options = {}) {
    if (!options.doNotUpdate) {
      this.update();
    }
    return readCookie(this.cookies[name], options);
  }
  getAll(options = {}) {
    if (!options.doNotUpdate) {
      this.update();
    }
    const result = {};
    for (let name in this.cookies) {
      result[name] = readCookie(this.cookies[name], options);
    }
    return result;
  }
  set(name, value, options) {
    if (options) {
      options = Object.assign(Object.assign({}, this.defaultSetOptions), options);
    } else {
      options = this.defaultSetOptions;
    }
    const stringValue = typeof value === "string" ? value : JSON.stringify(value);
    this.cookies = Object.assign(Object.assign({}, this.cookies), { [name]: stringValue });
    if (this.HAS_DOCUMENT_COOKIE) {
      document.cookie = cookieExports.serialize(name, stringValue, options);
    }
    this._emitChange({ name, value, options });
  }
  remove(name, options) {
    const finalOptions = options = Object.assign(Object.assign(Object.assign({}, this.defaultSetOptions), options), { expires: new Date(1970, 1, 1, 0, 0, 1), maxAge: 0 });
    this.cookies = Object.assign({}, this.cookies);
    delete this.cookies[name];
    if (this.HAS_DOCUMENT_COOKIE) {
      document.cookie = cookieExports.serialize(name, "", finalOptions);
    }
    this._emitChange({ name, value: void 0, options });
  }
  addChangeListener(callback) {
    this.changeListeners.push(callback);
    if (this.HAS_DOCUMENT_COOKIE && this.changeListeners.length === 1) {
      if (typeof window === "object" && "cookieStore" in window) {
        window.cookieStore.addEventListener("change", this.update);
      } else {
        this._startPolling();
      }
    }
  }
  removeChangeListener(callback) {
    const idx = this.changeListeners.indexOf(callback);
    if (idx >= 0) {
      this.changeListeners.splice(idx, 1);
    }
    if (this.HAS_DOCUMENT_COOKIE && this.changeListeners.length === 0) {
      if (typeof window === "object" && "cookieStore" in window) {
        window.cookieStore.removeEventListener("change", this.update);
      } else {
        this._stopPolling();
      }
    }
  }
}
const CookiesContext = React.createContext(new Cookies());
typeof SuppressedError === "function" ? SuppressedError : function(error, suppressed, message) {
  var e = new Error(message);
  return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
var reactIs = { exports: {} };
var reactIs_production_min = {};
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var hasRequiredReactIs_production_min;
function requireReactIs_production_min() {
  if (hasRequiredReactIs_production_min) return reactIs_production_min;
  hasRequiredReactIs_production_min = 1;
  var b = "function" === typeof Symbol && Symbol.for, c = b ? Symbol.for("react.element") : 60103, d = b ? Symbol.for("react.portal") : 60106, e = b ? Symbol.for("react.fragment") : 60107, f = b ? Symbol.for("react.strict_mode") : 60108, g = b ? Symbol.for("react.profiler") : 60114, h = b ? Symbol.for("react.provider") : 60109, k = b ? Symbol.for("react.context") : 60110, l = b ? Symbol.for("react.async_mode") : 60111, m = b ? Symbol.for("react.concurrent_mode") : 60111, n = b ? Symbol.for("react.forward_ref") : 60112, p = b ? Symbol.for("react.suspense") : 60113, q = b ? Symbol.for("react.suspense_list") : 60120, r = b ? Symbol.for("react.memo") : 60115, t = b ? Symbol.for("react.lazy") : 60116, v = b ? Symbol.for("react.block") : 60121, w = b ? Symbol.for("react.fundamental") : 60117, x = b ? Symbol.for("react.responder") : 60118, y = b ? Symbol.for("react.scope") : 60119;
  function z(a) {
    if ("object" === typeof a && null !== a) {
      var u = a.$$typeof;
      switch (u) {
        case c:
          switch (a = a.type, a) {
            case l:
            case m:
            case e:
            case g:
            case f:
            case p:
              return a;
            default:
              switch (a = a && a.$$typeof, a) {
                case k:
                case n:
                case t:
                case r:
                case h:
                  return a;
                default:
                  return u;
              }
          }
        case d:
          return u;
      }
    }
  }
  function A(a) {
    return z(a) === m;
  }
  reactIs_production_min.AsyncMode = l;
  reactIs_production_min.ConcurrentMode = m;
  reactIs_production_min.ContextConsumer = k;
  reactIs_production_min.ContextProvider = h;
  reactIs_production_min.Element = c;
  reactIs_production_min.ForwardRef = n;
  reactIs_production_min.Fragment = e;
  reactIs_production_min.Lazy = t;
  reactIs_production_min.Memo = r;
  reactIs_production_min.Portal = d;
  reactIs_production_min.Profiler = g;
  reactIs_production_min.StrictMode = f;
  reactIs_production_min.Suspense = p;
  reactIs_production_min.isAsyncMode = function(a) {
    return A(a) || z(a) === l;
  };
  reactIs_production_min.isConcurrentMode = A;
  reactIs_production_min.isContextConsumer = function(a) {
    return z(a) === k;
  };
  reactIs_production_min.isContextProvider = function(a) {
    return z(a) === h;
  };
  reactIs_production_min.isElement = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === c;
  };
  reactIs_production_min.isForwardRef = function(a) {
    return z(a) === n;
  };
  reactIs_production_min.isFragment = function(a) {
    return z(a) === e;
  };
  reactIs_production_min.isLazy = function(a) {
    return z(a) === t;
  };
  reactIs_production_min.isMemo = function(a) {
    return z(a) === r;
  };
  reactIs_production_min.isPortal = function(a) {
    return z(a) === d;
  };
  reactIs_production_min.isProfiler = function(a) {
    return z(a) === g;
  };
  reactIs_production_min.isStrictMode = function(a) {
    return z(a) === f;
  };
  reactIs_production_min.isSuspense = function(a) {
    return z(a) === p;
  };
  reactIs_production_min.isValidElementType = function(a) {
    return "string" === typeof a || "function" === typeof a || a === e || a === m || a === g || a === f || a === p || a === q || "object" === typeof a && null !== a && (a.$$typeof === t || a.$$typeof === r || a.$$typeof === h || a.$$typeof === k || a.$$typeof === n || a.$$typeof === w || a.$$typeof === x || a.$$typeof === y || a.$$typeof === v);
  };
  reactIs_production_min.typeOf = z;
  return reactIs_production_min;
}
var hasRequiredReactIs;
function requireReactIs() {
  if (hasRequiredReactIs) return reactIs.exports;
  hasRequiredReactIs = 1;
  {
    reactIs.exports = requireReactIs_production_min();
  }
  return reactIs.exports;
}
var hoistNonReactStatics_cjs;
var hasRequiredHoistNonReactStatics_cjs;
function requireHoistNonReactStatics_cjs() {
  if (hasRequiredHoistNonReactStatics_cjs) return hoistNonReactStatics_cjs;
  hasRequiredHoistNonReactStatics_cjs = 1;
  var reactIs2 = requireReactIs();
  var REACT_STATICS = {
    childContextTypes: true,
    contextType: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromError: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
  };
  var KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
  };
  var FORWARD_REF_STATICS = {
    "$$typeof": true,
    render: true,
    defaultProps: true,
    displayName: true,
    propTypes: true
  };
  var MEMO_STATICS = {
    "$$typeof": true,
    compare: true,
    defaultProps: true,
    displayName: true,
    propTypes: true,
    type: true
  };
  var TYPE_STATICS = {};
  TYPE_STATICS[reactIs2.ForwardRef] = FORWARD_REF_STATICS;
  TYPE_STATICS[reactIs2.Memo] = MEMO_STATICS;
  function getStatics(component) {
    if (reactIs2.isMemo(component)) {
      return MEMO_STATICS;
    }
    return TYPE_STATICS[component["$$typeof"]] || REACT_STATICS;
  }
  var defineProperty = Object.defineProperty;
  var getOwnPropertyNames = Object.getOwnPropertyNames;
  var getOwnPropertySymbols = Object.getOwnPropertySymbols;
  var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
  var getPrototypeOf = Object.getPrototypeOf;
  var objectPrototype = Object.prototype;
  function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== "string") {
      if (objectPrototype) {
        var inheritedComponent = getPrototypeOf(sourceComponent);
        if (inheritedComponent && inheritedComponent !== objectPrototype) {
          hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
        }
      }
      var keys = getOwnPropertyNames(sourceComponent);
      if (getOwnPropertySymbols) {
        keys = keys.concat(getOwnPropertySymbols(sourceComponent));
      }
      var targetStatics = getStatics(targetComponent);
      var sourceStatics = getStatics(sourceComponent);
      for (var i = 0; i < keys.length; ++i) {
        var key = keys[i];
        if (!KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
          var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
          try {
            defineProperty(targetComponent, key, descriptor);
          } catch (e) {
          }
        }
      }
    }
    return targetComponent;
  }
  hoistNonReactStatics_cjs = hoistNonReactStatics;
  return hoistNonReactStatics_cjs;
}
requireHoistNonReactStatics_cjs();
function isInBrowser() {
  return typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined";
}
function useCookies(dependencies, options) {
  const cookies = useContext(CookiesContext);
  if (!cookies) {
    throw new Error("Missing <CookiesProvider>");
  }
  const defaultOptions = { doNotUpdate: true };
  const getOptions = Object.assign(Object.assign({}, defaultOptions), options);
  const [allCookies, setCookies] = useState(() => cookies.getAll(getOptions));
  if (isInBrowser()) {
    useLayoutEffect(() => {
      function onChange() {
        const newCookies = cookies.getAll(getOptions);
        if (shouldUpdate(dependencies || null, newCookies, allCookies)) {
          setCookies(newCookies);
        }
      }
      cookies.addChangeListener(onChange);
      return () => {
        cookies.removeChangeListener(onChange);
      };
    }, [cookies, allCookies]);
  }
  const setCookie = useMemo(() => cookies.set.bind(cookies), [cookies]);
  const removeCookie = useMemo(() => cookies.remove.bind(cookies), [cookies]);
  const updateCookies = useMemo(() => cookies.update.bind(cookies), [cookies]);
  return [allCookies, setCookie, removeCookie, updateCookies];
}
function shouldUpdate(dependencies, newCookies, oldCookies) {
  if (!dependencies) {
    return true;
  }
  for (let dependency of dependencies) {
    if (newCookies[dependency] !== oldCookies[dependency]) {
      return true;
    }
  }
  return false;
}
const slugify = (text) => {
  const placeholder = String(text);
  if (placeholder === "") {
    return "";
  }
  const slug = placeholder.toLowerCase().replace(/\s+/g, "-").replace(/[^a-z0-9-]/g, "-").replace(/-{2,}/g, "-").replace(/^-|-$/g, "");
  return slug !== "" ? slug : "-";
};
const addQueryParams = (url, params) => {
  url = url.replace("{{sourceid}}", params.sourceid || "").replace("{{marketingclickid}}", params.marketingclickid || "");
  const urlObj = new URL(url);
  Object.keys(params).forEach((key) => {
    if (params[key] != null && !url.includes(`${key}=`)) {
      urlObj.searchParams.append(key, params[key]);
    }
  });
  return urlObj.toString();
};
const useSourceIdCookie = () => {
  const { environment: currentEnv } = useContext(GlobalHeadContext);
  const [{ sourceid }, setCookie] = useCookies([`${SOURCE_KEY}`]);
  const [location, setLocation] = useState(null);
  useEffect(() => {
    const { search = null } = (window == null ? void 0 : window.location) ?? {};
    setLocation(window == null ? void 0 : window.location);
    if (!search) return;
    const sourceIdParam = new URLSearchParams(search).get(`${SOURCE_KEY}`);
    if (sourceIdParam) {
      setCookie(`${SOURCE_KEY}`, `${sourceIdParam.substring(0, 99)}`, {
        path: "/",
        // make accessible for all pages
        domain: getEnvVariable({ currentEnv, keyToSearch: "COOKIE_DOMAIN" }),
        expires: new Date(Date.now() + COOKIE_EXPIRATION_TIME)
        // 365 days
      });
    }
  }, [sourceid, setCookie]);
  return {
    sourceid,
    location,
    setCookie
  };
};
function getDefaultExportFromCjs(x) {
  return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, "default") ? x["default"] : x;
}
var propTypes = { exports: {} };
var ReactPropTypesSecret$1 = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
var ReactPropTypesSecret_1 = ReactPropTypesSecret$1;
var ReactPropTypesSecret = ReactPropTypesSecret_1;
function emptyFunction() {
}
function emptyFunctionWithReset() {
}
emptyFunctionWithReset.resetWarningCache = emptyFunction;
var factoryWithThrowingShims = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      return;
    }
    var err = new Error(
      "Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types"
    );
    err.name = "Invariant Violation";
    throw err;
  }
  shim.isRequired = shim;
  function getShim() {
    return shim;
  }
  var ReactPropTypes = {
    array: shim,
    bigint: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,
    any: shim,
    arrayOf: getShim,
    element: shim,
    elementType: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim,
    checkPropTypes: emptyFunctionWithReset,
    resetWarningCache: emptyFunction
  };
  ReactPropTypes.PropTypes = ReactPropTypes;
  return ReactPropTypes;
};
{
  propTypes.exports = factoryWithThrowingShims();
}
var propTypesExports = propTypes.exports;
const PropTypes = /* @__PURE__ */ getDefaultExportFromCjs(propTypesExports);
const LogoImage$1 = styled("img")({
  width: "100%",
  height: "100%",
  objectFit: "contain",
  "&:hover": {
    cursor: "pointer"
  }
});
const convertHrefToUrl = (href, baseUrl) => {
  try {
    return new URL(href).href;
  } catch (e) {
    return new URL(href, baseUrl).href;
  }
};
const isOffSite = (hostname, href, target) => {
  var _a;
  if (!hostname) return true;
  if (target === "_blank") return true;
  const url = convertHrefToUrl(href, ((_a = window == null ? void 0 : window.location) == null ? void 0 : _a.href) || `https://${hostname}`);
  return !url.includes(hostname);
};
const getLocalPath = (href, property = null) => {
  const url = new URL(href, "https://www.quickenloans.com");
  if (property) return url[property];
  return `${url.pathname}${url.search}${url.hash}`;
};
const LinkResolver = forwardRef(({
  href,
  target = "_self",
  ...props
}, ref) => {
  const { LinkComponent: Link, uat, hostname, hostPlatform } = useContext(GlobalHeadContext);
  const linkType = hostPlatform === HOST_PLATFORM.GATSBY ? LINK_TYPES.GATSBY : LINK_TYPES.NEXT;
  const linkAttribute = {
    [linkType]: href
  };
  const linkProps = {
    ...props
  };
  if (!href || href === "#") {
    return /* @__PURE__ */ jsx("button", { ...linkProps });
  }
  linkProps.itemProp = "url";
  const uatHref = hostPlatform === HOST_PLATFORM.GATSBY ? "/eval-target" : href;
  const anchorHref = uat ? uatHref : href;
  const localPath = getLocalPath(anchorHref);
  linkAttribute[linkType] = uat ? uatHref : localPath;
  const isSameHostname = uat || hostname === getLocalPath(href, "hostname");
  let isSamePathname = false;
  if (typeof window !== "undefined") {
    isSamePathname = uat ? getLocalPath(window.location.href).toLowerCase().startsWith(localPath.toLowerCase()) : getLocalPath(window.location.href).toLowerCase() === localPath.toLowerCase();
  }
  const isOffSiteHref = uat ? false : isOffSite(hostname, anchorHref, target);
  let shouldRenderAnchor = Link === "a";
  if (isSameHostname && isSamePathname) shouldRenderAnchor = true;
  if (isOffSiteHref) shouldRenderAnchor = true;
  if (shouldRenderAnchor) {
    return /* @__PURE__ */ jsx("a", { ref, href: anchorHref, target, ...linkProps });
  }
  linkProps["data-type"] = "hostlink";
  return /* @__PURE__ */ jsx(Link, { ref, ...linkAttribute, ...linkProps, "data-name": "host-link" });
});
LinkResolver.propTypes = {
  /** The URL to navigate to */
  href: PropTypes.string,
  /** The target attribute for the link */
  target: PropTypes.string
};
function Logo({ showLarge, sx = {}, testId = "global-header-logo" }) {
  const { environment: currentEnv } = useContext(GlobalHeadContext);
  const logoSrc = showLarge ? logoLarge : logoSmall;
  const href = getEnvVariable({
    currentEnv,
    keyToSearch: "APP_BASE_URL"
  });
  return /* @__PURE__ */ jsx(LinkResolver, { id: "global-header-logo", href, children: /* @__PURE__ */ jsx(
    LogoImage$1,
    {
      src: logoSrc,
      alt: "Quicken Loans logo",
      title: "Quicken Loans logo",
      role: "img",
      "aria-label": ARIA_LABELS.LOGO,
      sx,
      "data-testid": testId
    }
  ) });
}
Logo.propTypes = {
  showLarge: PropTypes.bool,
  sx: PropTypes.object,
  testId: PropTypes.string
};
const StyledIconButton = ({ isActive, children, ...rest }) => /* @__PURE__ */ jsx(IconButton, { ...rest, children });
const StyledButton$1 = styled$1(StyledIconButton)(({ theme, isActive }) => {
  var _a, _b, _c, _d, _e, _f, _g, _h;
  return {
    padding: 8,
    color: isActive ? (_a = theme.vars.palette.grey) == null ? void 0 : _a[80] : (_b = theme.vars.palette.grey) == null ? void 0 : _b[70],
    background: isActive ? (_c = theme.vars.palette.grey) == null ? void 0 : _c[10] : (_d = theme.vars.palette.grey) == null ? void 0 : _d[0],
    "&:hover": {
      color: (_e = theme.vars.palette.grey) == null ? void 0 : _e[80],
      background: (_f = theme.vars.palette.grey) == null ? void 0 : _f[5]
    },
    "&:active": {
      color: (_g = theme.vars.palette.grey) == null ? void 0 : _g[90],
      background: (_h = theme.vars.palette.grey) == null ? void 0 : _h[10]
    },
    "&:focus-visible": {
      outline: "auto 1px"
    }
  };
});
const SearchIcon = ({
  onClick = () => {
  },
  isActive = false
}) => {
  return /* @__PURE__ */ jsx(
    StyledButton$1,
    {
      size: "small",
      id: "SearchIconButton",
      "data-testid": "SearchIconButton",
      disableRipple: true,
      onClick,
      "aria-label": ARIA_LABELS.SEARCH_ICON,
      role: "button",
      isActive,
      children: /* @__PURE__ */ jsx(Search, {})
    }
  );
};
SearchIcon.propTypes = {
  onClick: PropTypes.func,
  isActive: PropTypes.bool
};
const getFlexAlignment = (hasChildren, hasIcon) => ({
  justifyContent: hasIcon && hasChildren ? "space-between" : "center",
  alignItems: "center"
});
const getPadding = (hasChildren, hasIcon) => {
  const paddingMap = {
    "true-true": "6px 4px 6px 8px",
    "true-false": "8px 12px 8px 8px",
    "false-true": "8px 4px 8px 8px",
    "false-false": "8px"
  };
  const key = `${hasIcon}-${hasChildren}`;
  return paddingMap[key];
};
const getActiveStyles = (isActive) => isActive ? {
  color: "var(--color-primary-110)",
  background: "var(--color-primary-005)"
} : {};
const IconWrapper = styled$1("div")({
  display: "inline-flex",
  justifyContent: "flex-end",
  alignItems: "center",
  flexGrow: 1
});
const IconSpan = styled$1("div")({
  display: "inline-flex",
  justifyContent: "flex-end",
  alignItems: "center",
  width: "20px",
  height: "20px",
  svg: {
    width: "100%",
    height: "100%"
  }
});
const Container = styled$1("div")(({
  theme,
  hasChildren = false,
  hasIcon = false,
  isActive = false,
  isForMainNav = false
}) => {
  var _a, _b, _c, _d, _e, _f, _g, _h;
  const { link } = theme["global-head"].nav.desktop;
  return {
    ...getFlexAlignment(hasChildren, hasIcon),
    alignItems: "center",
    backgroundColor: "transparent",
    borderRadius: `${isForMainNav ? "0" : `${link.borderRadius}`}px`,
    boxSizing: "border-box",
    display: "inline-flex",
    flexShrink: 0,
    gap: `${link.gap}px`,
    height: `${link.height}px`,
    maxHeight: `${link.height}px`,
    justifyContent: "flex-start",
    outline: "none",
    padding: getPadding(hasChildren, hasIcon),
    textDecoration: "none",
    width: "100%",
    cursor: "pointer",
    WebkitTapHighlightColor: "transparent",
    /* Remove the ripple effect on mobile devices */
    ...isForMainNav ? {
      borderBottom: "2px solid transparent",
      transition: "border-bottom 0.3s ease, background-color 0.3s ease",
      "&:hover": {
        borderBottom: `2px solid ${(_a = theme.vars.palette.primary) == null ? void 0 : _a[100]}`,
        ...isActive ? {
          span: {
            color: (_b = theme.vars.palette.primary) == null ? void 0 : _b[100]
          }
        } : {}
      },
      ...isActive ? {
        borderBottom: `2px solid ${(_c = theme.vars.palette.primary) == null ? void 0 : _c[100]}`,
        span: {
          color: (_d = theme.vars.palette.primary) == null ? void 0 : _d[100]
        }
      } : {}
    } : {
      "@media (hover: hover)": {
        // allow hover styles on devices that support it
        "&:hover": {
          background: (_e = theme.vars.palette.primary) == null ? void 0 : _e[5]
        }
      },
      "&:active": {
        // preserve style when clicking on touch devices
        background: (_f = theme.vars.palette.primary) == null ? void 0 : _f[5]
      }
    },
    svg: {
      fill: isActive ? (_g = theme.vars.palette.primary) == null ? void 0 : _g[110] : (_h = theme.vars.palette.grey) == null ? void 0 : _h[80]
    },
    [theme.breakpoints.up(BREAKPOINT_DIMENSIONS.extra_large)]: {
      width: "auto"
    },
    ...getActiveStyles(isActive && !isForMainNav)
  };
});
const LinkWrapper = styled$1(forwardRef(({
  hasChildren,
  hasIcon,
  isActive,
  isForMainNav,
  theme,
  ...rest
}, ref) => /* @__PURE__ */ jsx(LinkResolver, { ref, ...rest })))(({ isActive = false, theme = {} }) => {
  var _a, _b;
  return {
    boxShadow: "none",
    color: isActive ? (_a = theme.vars.palette.primary) == null ? void 0 : _a[110] : (_b = theme.vars.palette.grey) == null ? void 0 : _b[80],
    fontFamily: theme.typography.fontFamily,
    display: "inline-flex",
    alignItems: "center",
    gap: "8px",
    padding: 0,
    textDecoration: "none",
    backgroundColor: "transparent",
    borderWidth: 0,
    fontSize: theme.typography.htmlFontSize,
    fontStyle: "normal",
    fontWeight: theme.typography.fontWeightRegular,
    lineHeight: theme.customSpacing.lineHeight,
    cursor: "pointer",
    span: {
      maxHeight: "37px",
      overflow: "hidden",
      textAlign: "left"
    }
  };
});
const LinkIcon = ({ icon, testId }) => /* @__PURE__ */ jsx(IconWrapper, { "data-testid": testId, children: /* @__PURE__ */ jsx(IconSpan, { children: icon }) });
const LinkTitle = ({ testId, title, ...rest }) => /* @__PURE__ */ jsx("span", { "data-testid": testId, ...rest, children: title });
const NavigationLinkContainer = ({ className, icon, onClick, sx, title, linkWrapperRef, ...rest }) => {
  var _a;
  const defaultTestId = slugify(`n-link-${title}`);
  const titleItemProp = ((_a = rest == null ? void 0 : rest.href) == null ? void 0 : _a.length) && rest.href !== "#" ? "name" : null;
  return /* @__PURE__ */ jsxs(
    Container,
    {
      className,
      "data-testid": `${defaultTestId}-container`,
      onClick,
      sx,
      ...rest,
      children: [
        /* @__PURE__ */ jsxs(
          LinkWrapper,
          {
            ref: linkWrapperRef,
            "aria-selected": (rest == null ? void 0 : rest.isActive) ? "true" : "false",
            "data-testid": `${defaultTestId}-wrapper`,
            id: `${defaultTestId}-wrapper-${rest.isForMainNav ? "main" : "sub"}`,
            ...rest,
            children: [
              (rest == null ? void 0 : rest.hasIcon) && /* @__PURE__ */ jsx(LinkIcon, { icon, testId: `${defaultTestId}-icon-left` }),
              /* @__PURE__ */ jsx(LinkTitle, { testId: `${defaultTestId}-title`, title, itemProp: titleItemProp })
            ]
          }
        ),
        (rest == null ? void 0 : rest.hasChildren) && /* @__PURE__ */ jsx(LinkIcon, { icon: /* @__PURE__ */ jsx(ChevronRight, {}), testId: `${defaultTestId}-icon-right` })
      ]
    }
  );
};
const NavigationLink = ({
  className = "",
  hasChildren = false,
  href,
  target,
  icon,
  isActive = false,
  isForMainNav = true,
  onClick = () => {
  },
  title,
  sx = {}
}) => {
  const linkWrapperRef = createRef();
  const hasIcon = Boolean(icon);
  const handleClick = (event) => {
    if (linkWrapperRef.current) {
      linkWrapperRef.current.click();
      return;
    }
    onClick(event);
  };
  return /* @__PURE__ */ jsx(
    NavigationLinkContainer,
    {
      className,
      hasChildren,
      hasIcon,
      href,
      target,
      icon,
      isActive,
      isForMainNav,
      onClick: handleClick,
      sx,
      title,
      linkWrapperRef
    }
  );
};
NavigationLink.propTypes = {
  /** Static className that will allow overriding CSS module styling */
  className: PropTypes.string,
  /** When set to true it add the chevron right icon */
  hasChildren: PropTypes.bool,
  /** The URL to navigate to. If not provided, the NavigationLink will render as a button */
  href: PropTypes.string,
  /** The target attribute for the link */
  target: PropTypes.string,
  /** Inline SVG or a component that renders to an inline SVG. Will either appear left of text or in the center if there is not text provided. */
  icon: PropTypes.element,
  /** When set to true the background and font color will be changed */
  isActive: PropTypes.bool,
  /** When set to true the border radius will be removed */
  isForMainNav: PropTypes.bool,
  onClick: PropTypes.func,
  /** The system prop that allows defining system overrides as well as additional CSS styles */
  sx: PropTypes.object,
  /** NavigationLink title */
  title: PropTypes.string.isRequired
};
const HamburgerIconStyled = styled$1("svg")({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  "&.open": {
    "& .top": {
      transform: "translate(0px, 5px) rotate(45deg)"
    },
    "& .middle": {
      transform: "scaleX(0)",
      opacity: 0
    },
    "& .bottom": {
      transform: "translate(0px, -5px) rotate(-45deg)"
    }
  }
});
const RectStyled = styled$1("rect")(({ theme }) => {
  var _a;
  return {
    transformOrigin: "center",
    transformBox: "fill-box",
    width: 20,
    height: 2,
    x: 2,
    fill: (_a = theme.vars.palette.grey) == null ? void 0 : _a[80],
    transition: "all 0.3s ease-in-out"
  };
});
const defaultStyles = {
  padding: 0,
  "&:focus-visible": {
    outline: "auto 1px black"
  }
};
const HamburgerButton = ({
  sx = {},
  isOpen = false,
  onClick = () => {
  },
  testId = "hamburger-button"
}) => {
  return /* @__PURE__ */ jsx(
    IconButton,
    {
      sx: { ...defaultStyles, ...sx },
      size: "small",
      id: "hamburger-button",
      "data-testid": testId,
      disableRipple: true,
      onClick,
      "aria-label": ARIA_LABELS.NAVIGATION_MENU,
      "aria-expanded": isOpen,
      role: "button",
      children: /* @__PURE__ */ jsxs(
        HamburgerIconStyled,
        {
          "data-testid": `${testId}-icon`,
          className: isOpen ? "open" : "",
          children: [
            /* @__PURE__ */ jsx(RectStyled, { y: "6.5", className: "top" }),
            /* @__PURE__ */ jsx(RectStyled, { y: "11.5", className: "middle" }),
            /* @__PURE__ */ jsx(RectStyled, { y: "16.5", className: "bottom" })
          ]
        }
      )
    }
  );
};
HamburgerButton.propTypes = {
  sx: PropTypes.object,
  isOpen: PropTypes.bool,
  onClick: PropTypes.func,
  testId: PropTypes.string
};
const StyledSkeleton = styled$1(Skeleton$1)(({ variant, sx }) => {
  const reverseAnimation = (sx == null ? void 0 : sx.reverseAnimation) ?? false;
  return {
    backgroundColor: "#d3d3d3",
    ...variant === SKELETON_VARIANTS.ROUNDED_RECT && {
      borderRadius: "100px"
    },
    ...variant === SKELETON_VARIANTS.ROUNDED && {
      borderRadius: "10px"
    },
    ...reverseAnimation && {
      opacity: 0.4,
      animation: "skeletonInvert 2s ease-in-out 0.5s infinite"
    },
    ...reverseAnimation && {
      "@keyframes skeletonInvert": {
        "0%": {
          opacity: 0.4
        },
        "50%": {
          opacity: 1
        },
        "100%": {
          opacity: 0.4
        }
      }
    }
  };
});
const Skeleton = ({ variant, ...props }) => {
  return /* @__PURE__ */ jsx(StyledSkeleton, { "data-testid": `${variant}-skeleton`, variant, ...props });
};
Skeleton.protoType = {
  variant: PropTypes.oneOf(Object.values(SKELETON_VARIANTS))
};
const getColors = (theme) => {
  var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j, _k, _l, _m, _n, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _A;
  return {
    active: (_c = (_b = (_a = theme == null ? void 0 : theme.vars) == null ? void 0 : _a.palette) == null ? void 0 : _b.primary) == null ? void 0 : _c[110],
    default: (_f = (_e = (_d = theme == null ? void 0 : theme.vars) == null ? void 0 : _d.palette) == null ? void 0 : _e.grey) == null ? void 0 : _f[60],
    defaultBackground: (_i = (_h = (_g = theme == null ? void 0 : theme.vars) == null ? void 0 : _g.palette) == null ? void 0 : _h.grey) == null ? void 0 : _i[0],
    disabled: (_l = (_k = (_j = theme == null ? void 0 : theme.vars) == null ? void 0 : _j.palette) == null ? void 0 : _k.grey) == null ? void 0 : _l[30],
    error: (_o = (_n = (_m = theme == null ? void 0 : theme.vars) == null ? void 0 : _m.palette) == null ? void 0 : _n.secondary) == null ? void 0 : _o[90],
    filled: (_r = (_q = (_p = theme == null ? void 0 : theme.vars) == null ? void 0 : _p.palette) == null ? void 0 : _q.grey) == null ? void 0 : _r[70],
    label: {
      active: (_u = (_t = (_s = theme == null ? void 0 : theme.vars) == null ? void 0 : _s.palette) == null ? void 0 : _t.primary) == null ? void 0 : _u[100],
      error: (_x = (_w = (_v = theme == null ? void 0 : theme.vars) == null ? void 0 : _v.palette) == null ? void 0 : _w.secondary) == null ? void 0 : _x[90]
    },
    supportingText: {
      active: (_A = (_z = (_y = theme == null ? void 0 : theme.vars) == null ? void 0 : _y.palette) == null ? void 0 : _z.grey) == null ? void 0 : _A[50]
    }
  };
};
const StyledBox$1 = styled(Box)(() => ({
  boxSizing: "border-box",
  display: "flex",
  flexDirection: "column",
  flexShrink: 0,
  marginBottom: 20,
  width: "100%"
}));
const StyledAdornment = styled(({ hasPointer, isDisabled, ...rest }) => /* @__PURE__ */ jsx(InputAdornment, { ...rest }))(({ hasPointer, isDisabled }) => ({
  "&.MuiInputAdornment-root": {
    marginRight: 0,
    "svg, img": {
      flexShrink: 0,
      height: 24,
      width: 24
    },
    ...hasPointer ? { cursor: "pointer" } : {},
    ...isDisabled ? { opacity: 0.5 } : {}
  }
}));
const StyledLabel = styled(InputLabel)(({ theme, state = "default" }) => {
  var _a, _b;
  const colors = getColors(theme);
  return {
    color: (colors == null ? void 0 : colors[state]) ?? colors.default,
    fontSize: 12,
    fontStyle: "normal",
    fontFamily: (_a = theme == null ? void 0 : theme.typography) == null ? void 0 : _a.fontFamily,
    fontWeight: 600,
    lineHeight: (_b = theme == null ? void 0 : theme.customSpacing) == null ? void 0 : _b.lineHeight,
    margin: "0 0 2px 17px",
    "&.Mui-disabled": {
      color: colors.disabled
    },
    "&.Mui-error": {
      color: colors.label.error
    },
    "&.Mui-focused": {
      color: colors.label.active
    }
  };
});
const StyledSupportingText = styled(FormHelperText)(({ theme, state = "default" }) => {
  var _a, _b, _c;
  const colors = getColors(theme);
  return {
    color: (colors == null ? void 0 : colors[state]) ?? colors.default,
    fontSize: 12,
    fontStyle: "normal",
    fontFamily: (_a = theme == null ? void 0 : theme.typography) == null ? void 0 : _a.fontFamily,
    fontWeight: (_b = theme == null ? void 0 : theme.typography) == null ? void 0 : _b.fontWeightRegular,
    lineHeight: (_c = theme == null ? void 0 : theme.customSpacing) == null ? void 0 : _c.lineHeight,
    margin: "4px 0 0 17px",
    "&.Mui-disabled": {
      color: colors.disabled
    },
    "&.Mui-error": {
      color: colors.label.error
    },
    "&.Mui-focused": {
      color: colors.supportingText.active
    }
  };
});
const StyledInput = styled(
  ({ shouldReducePaddingRight = false, state = "default", theme, ...rest }) => /* @__PURE__ */ jsx(OutlinedInput, { ...rest })
)(({ theme, shouldReducePaddingRight, state }) => {
  var _a, _b, _c;
  const colors = getColors(theme);
  return {
    backgroundColor: colors.defaultBackground,
    borderRadius: 10,
    boxSizing: "border-box",
    color: (colors == null ? void 0 : colors[state]) ?? colors.default,
    flexShrink: 0,
    fontSize: 16,
    fontStyle: "normal",
    fontWeight: (_a = theme == null ? void 0 : theme.typography) == null ? void 0 : _a.fontWeightRegular,
    gap: 8,
    height: 50,
    lineHeight: (_b = theme == null ? void 0 : theme.customSpacing) == null ? void 0 : _b.lineHeight,
    padding: `0 ${shouldReducePaddingRight ? "12px" : "14px"} 0 14px`,
    maxWidth: 288,
    "& .MuiOutlinedInput-input": {
      boxSizing: "border-box",
      height: 50,
      padding: 0,
      width: 288,
      "&.Mui-disabled": {
        color: colors.disabled,
        WebkitTextFillColor: colors.disabled
      },
      "::placeholder": {
        fontFamily: (_c = theme == null ? void 0 : theme.typography) == null ? void 0 : _c.fontFamily,
        color: (colors == null ? void 0 : colors[state]) ?? colors.default,
        opacity: 1
      }
    },
    "&.Mui-disabled": {
      color: colors.disabled,
      "&:hover": {
        "& .MuiOutlinedInput-notchedOutline": {
          border: `1.5px solid ${colors.disabled}`
        }
      },
      "& .MuiOutlinedInput-notchedOutline": {
        border: `1.5px solid ${colors.disabled}`
      }
    },
    "&.Mui-error": {
      color: colors.filled,
      paddingRight: 14,
      "& .MuiOutlinedInput-notchedOutline": {
        border: `1.5px solid ${colors.error}`
      },
      "&:hover": {
        "& .MuiOutlinedInput-notchedOutline": {
          border: `1.5px solid ${colors.error}`
        }
      }
    },
    "&.Mui-focused": {
      color: colors.filled,
      paddingRight: 14,
      "& .MuiOutlinedInput-notchedOutline": {
        border: `1.5px solid ${colors.active}`
      },
      "&:hover": {
        "& .MuiOutlinedInput-notchedOutline": {
          border: `1.5px solid ${colors.active}`
        }
      }
    },
    "&:hover": {
      "& .MuiOutlinedInput-notchedOutline": {
        border: `1.5px solid ${(colors == null ? void 0 : colors[state]) ?? colors.default}`
      }
    },
    "& .MuiOutlinedInput-notchedOutline": {
      border: `1.5px solid ${(colors == null ? void 0 : colors[state]) ?? colors.default}`
    }
  };
});
const getAdornments = ({ clearAction, icon, iconAlt, isDisabled }) => {
  const adornment = {};
  if (icon) {
    const renderIcon = () => {
      switch (typeof icon) {
        case "function":
          return icon();
        case "object":
          const Icon = icon;
          return /* @__PURE__ */ jsx(Icon, {});
        case "string":
          return /* @__PURE__ */ jsx("img", { src: icon, alt: iconAlt ?? "start adornment" });
        default:
          throw new Error("Invalid icon type");
      }
    };
    adornment.startAdornment = /* @__PURE__ */ jsx(
      StyledAdornment,
      {
        "data-testid": "textField__startAdornment",
        isDisabled,
        position: "start",
        variant: "outlined",
        children: renderIcon()
      }
    );
  }
  if (clearAction) {
    adornment.endAdornment = /* @__PURE__ */ jsx(StyledAdornment, { hasPointer: true, position: "end", children: /* @__PURE__ */ jsx(
      Close,
      {
        tabIndex: 0,
        "aria-hidden": "false",
        "data-testid": clearAction.dataTestId ?? "textField__endAdornment",
        onClick: clearAction.onClick,
        onKeyDown: (event) => {
          if (event.key === "Enter") {
            event.preventDefault();
            clearAction.onClick();
          }
        }
      }
    ) });
  }
  return adornment;
};
const TextField = ({
  autoComplete = "off",
  autoFocus = false,
  boxClassName = "",
  defaultValue = "",
  icon,
  iconAlt,
  id = "testId",
  inputClassName = "",
  isDisabled = false,
  label,
  labelClassName,
  onInputBlur = () => {
  },
  onInputChange = () => {
  },
  onInputFocused = () => {
  },
  placeholder,
  shouldBeShownAsError = false,
  supportingText = "",
  supportingTextClassName,
  sx = {},
  ...props
}) => {
  const inputRef = useRef(null);
  const [value, setValue] = useState(defaultValue);
  const [isFocused, setIsFocused] = useState(autoFocus);
  const [hasError, setHasError] = useState(shouldBeShownAsError || false);
  useEffect(() => {
    if (defaultValue !== value) {
      setValue(defaultValue);
    }
  }, [defaultValue]);
  useEffect(() => {
    setHasError(shouldBeShownAsError);
  }, [shouldBeShownAsError]);
  const handleChange = (event) => {
    var _a;
    const value2 = (_a = event.target) == null ? void 0 : _a.value;
    setValue(value2);
    onInputChange({ value: value2, inputRef });
  };
  const handleClear = () => {
    setValue("");
    onInputChange({ value: "", inputRef });
    setHasError(false);
    inputRef.current.focus();
  };
  const handleFocus = () => {
    setIsFocused(true);
    onInputFocused({ value, inputRef });
  };
  const handleBlur = () => {
    setIsFocused(false);
    onInputBlur({ value, inputRef });
  };
  const clearAction = !isDisabled && value ? { onClick: handleClear, dataTestId: `textField__clearButton--${id}` } : null;
  const inputState = (value == null ? void 0 : value.length) ? "filled" : "default";
  const shouldReducePaddingRight = (supportingText == null ? void 0 : supportingText.length) > 0 && (inputState !== "filled" || isDisabled);
  return /* @__PURE__ */ jsxs(StyledBox$1, { className: boxClassName, sx, children: [
    label && /* @__PURE__ */ jsx(
      StyledLabel,
      {
        className: labelClassName,
        "data-testid": `textField__label--${id}`,
        disabled: isDisabled,
        error: !isFocused && hasError,
        focused: isFocused,
        state: inputState,
        htmlFor: id,
        children: label
      }
    ),
    /* @__PURE__ */ jsx(
      StyledInput,
      {
        autoComplete,
        autoFocus,
        className: inputClassName,
        "data-testid": `textField__${id}`,
        disabled: isDisabled,
        error: hasError,
        id,
        inputMode: "text",
        inputRef,
        onBlur: handleBlur,
        onChange: handleChange,
        onFocus: handleFocus,
        placeholder,
        shouldReducePaddingRight,
        state: inputState,
        value,
        ...getAdornments({
          clearAction,
          icon,
          iconAlt,
          isDisabled
        }),
        ...props
      }
    ),
    supportingText && /* @__PURE__ */ jsx(
      StyledSupportingText,
      {
        className: supportingTextClassName,
        "data-testid": `textField__helperText--${id}`,
        disabled: isDisabled,
        error: hasError,
        focused: isFocused,
        state: inputState,
        children: supportingText
      }
    )
  ] });
};
TextField.propTypes = {
  autoFocus: PropTypes.bool,
  autoComplete: PropTypes.oneOf(["on", "off"]),
  /** Css/sass styles to be applied to the StyledBox */
  boxClassName: PropTypes.string,
  /** If exists, the value already stored for this input */
  defaultValue: PropTypes.string,
  /** The svg or the component to be rendered */
  icon: PropTypes.oneOfType([PropTypes.string, PropTypes.elementType]),
  /** Alt used for the given svg */
  iconAlt: PropTypes.string,
  /** Will be used to identify the input */
  id: PropTypes.string,
  /** Css/sass styles to be applied to the StyledInput */
  inputClassName: PropTypes.string,
  isDisabled: PropTypes.bool,
  label: PropTypes.string,
  /** Css/sass styles to be applied to the StyledLabel */
  labelClassName: PropTypes.string,
  /** The following functions will be invoked when the events are triggered passing { value, inputRef } */
  onInputBlur: PropTypes.func,
  onInputChange: PropTypes.func,
  onInputFocused: PropTypes.func,
  /** Input basic placeholder */
  placeholder: PropTypes.string,
  /** Indicates if the input should be in an error state */
  shouldBeShownAsError: PropTypes.bool,
  /** Text to be shown as help for users */
  supportingText: PropTypes.string,
  /** Css/sass styles to be applied to the StyledSupportingText */
  supportingTextClassName: PropTypes.string,
  sx: PropTypes.object
};
const SourceIdLinkStyled = styled$1(BYOButton)(
  ({ theme }) => {
    return {
      "&:focus-visible": {
        outline: "auto 1px black"
      }
    };
  }
);
const SourceIdLink = ({
  children,
  href,
  ...props
}) => {
  const { sourceid } = useSourceIdCookie();
  const url = `${href}?sourceid=${sourceid || `${SOURCE_PREFIX}nav-start`}`;
  return /* @__PURE__ */ jsx(
    SourceIdLinkStyled,
    {
      color: "blue",
      style: "filled",
      href: url,
      ...props,
      children
    }
  );
};
SourceIdLink.propTypes = {
  /** Content or React Node */
  children: PropTypes.node.isRequired,
  /** URL */
  href: PropTypes.string.isRequired
};
function ProviderHighlights({
  highlights,
  clientId
}) {
  return (
    // Render the first three items 
    /* @__PURE__ */ jsx("ul", { "data-testid": `highlights-list-${clientId}`, children: highlights.slice(0, 3).map((item, index) => /* @__PURE__ */ jsx("li", { "data-testid": `highlight-item-${clientId}-${index}`, children: item }, index)) })
  );
}
ProviderHighlights.propTypes = {
  highlights: PropTypes.array.isRequired,
  clientId: PropTypes.string.isRequired
};
const LogoImage = styled("img")({
  width: "100%",
  height: "100%",
  objectFit: "contain"
});
function OfferLogo({
  sx = {},
  logoUrl,
  clientId,
  clientName
}) {
  return /* @__PURE__ */ jsx(
    LogoImage,
    {
      sx,
      src: logoUrl,
      alt: `${clientName} logo`,
      "data-testid": `offer-logo-${clientId}`
    }
  );
}
OfferLogo.propTypes = {
  sx: PropTypes.object,
  logoUrl: PropTypes.string.isRequired,
  clientId: PropTypes.string.isRequired,
  clientName: PropTypes.string.isRequired
};
const OfferCriteriaContainer = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  gap: "4px"
}));
const OfferCriteria = ({
  sx = {},
  criteria,
  clientId
}) => {
  const creditScoreCriteria = criteria.find((item) => item.type === CRITERIA_TYPE);
  if (!creditScoreCriteria) {
    return null;
  }
  const { min, max, description } = creditScoreCriteria;
  const criteriaValue = min && max ? `${min} – ${max}` : min || max;
  return /* @__PURE__ */ jsxs(OfferCriteriaContainer, { sx, "data-testid": `offer-criteria-${clientId}`, children: [
    /* @__PURE__ */ jsx("h3", { className: "criteria-value", "data-testid": `criteria-value-${clientId}`, children: criteriaValue }),
    /* @__PURE__ */ jsx("p", { "data-testid": `criteria-description-${clientId}`, children: description })
  ] });
};
OfferCriteria.propTypes = {
  sx: PropTypes.object,
  criteria: PropTypes.arrayOf(PropTypes.object).isRequired,
  clientId: PropTypes.string.isRequired
};
const OfferCtaContainer = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  gap: "8px"
}));
const OfferCta = ({
  sx = {},
  clientId,
  clientName,
  ctaButtonText,
  ctaUrl,
  ctaAdditionalText = null,
  sourceId,
  marketingClickId
}) => {
  const modifiedCtaUrl = addQueryParams(
    ctaUrl,
    {
      sourceid: sourceId,
      marketingclickid: marketingClickId
    }
  );
  const additionalText = ctaAdditionalText || `${OFFER_CTA_PREFIX} ${clientName}`;
  return /* @__PURE__ */ jsxs(OfferCtaContainer, { sx, "data-testid": `cta-section-${clientId}`, children: [
    /* @__PURE__ */ jsx(
      BYOButton,
      {
        color: "green",
        style: "filled",
        iconRight: /* @__PURE__ */ jsx(OpenInNewIcon, {}),
        href: modifiedCtaUrl,
        target: "_blank",
        "data-testid": `cta-button-${clientId}`,
        children: ctaButtonText
      }
    ),
    /* @__PURE__ */ jsx("p", { "data-testid": `cta-subtext-${clientId}`, children: additionalText })
  ] });
};
OfferCta.propTypes = {
  sx: PropTypes.object,
  clientId: PropTypes.string.isRequired,
  clientName: PropTypes.string.isRequired,
  ctaButtonText: PropTypes.string.isRequired,
  ctaUrl: PropTypes.string.isRequired,
  ctaAdditionalText: PropTypes.string,
  sourceId: PropTypes.string.isRequired,
  marketingClickId: PropTypes.string.isRequired
};
const convertNodesToSchema = (nodes) => {
  const schemaGraphs = nodes.reduce((graphs, node) => {
    var _a, _b, _c, _d, _e, _f, _g, _h;
    return [
      ...graphs,
      {
        "@type": "SiteNavigationElement",
        "name": ((_b = (_a = node.childItems) == null ? void 0 : _a.nodes) == null ? void 0 : _b.length) ? (_d = (_c = node.childItems) == null ? void 0 : _c.nodes) == null ? void 0 : _d.reduce((childNames, childNode) => [
          ...childNames,
          childNode.label
        ], []) : [node.label],
        "url": ((_f = (_e = node.childItems) == null ? void 0 : _e.nodes) == null ? void 0 : _f.length) ? (_h = (_g = node.childItems) == null ? void 0 : _g.nodes) == null ? void 0 : _h.reduce((childUrls, childNode) => [
          ...childUrls,
          childNode.url
        ], []) : [node.url]
      }
    ];
  }, []);
  return {
    "@context": "https://schema.org",
    "@graph": schemaGraphs
  };
};
const MenuSchema = () => {
  const { navigationLinkNodes } = useContext(GlobalHeadContext);
  return /* @__PURE__ */ jsx(
    "script",
    {
      type: "application/ld+json",
      dangerouslySetInnerHTML: {
        __html: JSON.stringify(convertNodesToSchema(navigationLinkNodes), null, 4)
      },
      "data-testid": "menu-schema-json"
    }
  );
};
const bodyNoScrollClass = "no-scroll";
let windowProperties = {
  scrollY: 0,
  scrollBehaviorStyle: ""
};
const setTabIndexes = (navOptionIndex = "-1", drawerOptionIndex = "0") => {
  const selectors = {
    navOptions: [
      '[id$="wrapper-main"]',
      "#hamburger-button",
      "#mobile-menu-icons",
      "#global-header-logo",
      "#SearchIconButton",
      "#search-cta-sign-in-button",
      "#search-cta-account-button",
      "#search-cta-get-started-button",
      "#search-cta-mobile-sign-in-button"
    ].join(", "),
    drawerOptions: [
      '[id$="wrapper-sub"]',
      "#nav-bar-mobile-header"
    ].join(", ")
  };
  const updateTabIndexes = (selector, tabIndex) => {
    document.querySelectorAll(selector).forEach((element) => {
      element.setAttribute("tabindex", tabIndex);
    });
  };
  updateTabIndexes(selectors.navOptions, navOptionIndex);
  updateTabIndexes(selectors.drawerOptions, drawerOptionIndex);
};
const handleTransitionEnter = () => {
  var _a, _b;
  windowProperties.scrollBehaviorStyle = (_b = (_a = document.documentElement) == null ? void 0 : _a.style) == null ? void 0 : _b.scrollBehavior;
  windowProperties.scrollY = (window == null ? void 0 : window.scrollY) ?? 0;
  if (document.body.scrollHeight > window.innerHeight) {
    document.body.style.overflowY = "scroll";
    document.body.style.top = `-${windowProperties.scrollY}px`;
  }
  document.body.classList.add(bodyNoScrollClass);
  document.documentElement.style.scrollBehavior = "auto";
  setTabIndexes();
};
const clearBodyNoScroll = (windowPropOverrides = {}) => {
  const ribbonContainer = document.getElementById("ribbon-container");
  const style = ribbonContainer ? window == null ? void 0 : window.getComputedStyle(ribbonContainer) : null;
  setTimeout(() => {
    if ((style == null ? void 0 : style.overflow) === "hidden") return;
    if (!document.body.classList.contains(bodyNoScrollClass)) return;
    const restoreProperties = {
      overflowY: "",
      ...windowProperties,
      ...windowPropOverrides
    };
    document.body.style.overflowY = restoreProperties.overflowY;
    document.body.style.top = 0;
    document.body.classList.remove(bodyNoScrollClass);
    if (typeof windowPropOverrides.scrollY !== "undefined") {
      setTimeout(() => window == null ? void 0 : window.scrollTo(0, restoreProperties.scrollY), 20);
    } else {
      window.scrollTo(0, restoreProperties.scrollY);
    }
    document.documentElement.style.scrollBehavior = restoreProperties.scrollBehaviorStyle;
  }, 20);
};
const handleTransitionExited = (drawerContainer) => {
  const style = window == null ? void 0 : window.getComputedStyle(drawerContainer);
  if ((style == null ? void 0 : style.overflow) === "visible") {
    clearBodyNoScroll();
    setTabIndexes("0", "-1");
  }
};
const getDrawerProps = ({
  ribbonParentRef,
  dataTestIdPaper = "",
  dataTestIdBackdrop = "",
  isMobile = false
}) => {
  const drawerContainer = ribbonParentRef == null ? void 0 : ribbonParentRef.current;
  const offsetHeight = (drawerContainer == null ? void 0 : drawerContainer.offsetHeight) ?? 0;
  const paperProps = {
    style: isMobile ? { height: `calc(100dvh - ${offsetHeight}px)` } : {},
    "data-testid": dataTestIdPaper
  };
  const backdropProps = {
    style: { position: "fixed" },
    "data-testid": dataTestIdBackdrop
  };
  const slideProps = {
    style: {
      top: `${offsetHeight}px`
    }
  };
  let modalProps = {
    disableAutoFocus: true,
    style: { position: "absolute" },
    keepMounted: true
  };
  if (drawerContainer) {
    modalProps = {
      ...modalProps,
      container: () => drawerContainer,
      onTransitionEnter: handleTransitionEnter,
      onTransitionExited: () => handleTransitionExited(drawerContainer)
    };
  }
  return {
    paperProps,
    backdropProps,
    slideProps,
    modalProps
  };
};
function useInRangeMediaQuery(minWidth, maxWidth) {
  const mediaQuery = useMediaQuery(
    `(min-width:${minWidth}px) and (max-width:${maxWidth}px)`,
    { noSsr: true }
  );
  return mediaQuery;
}
const ENVIRONMENTS$1 = {
  DEVELOPMENT: "development",
  PRODUCTION: "production",
  QA: "qa"
};
const useSearchBar = ({ isVisible = false }) => {
  const baseUrl = getEnvVariable({
    currentEnv: ENVIRONMENTS$1.PRODUCTION,
    // @todo: This variable should be taken from the GlobalHeadContext
    defaultValue: "https://www.quickenloans.com",
    keyToSearch: "APP_BASE_URL"
  });
  const [searchTerm, setSearchTerm] = useState("");
  const handleInputChange = (event) => setSearchTerm(event.value);
  useEffect(() => {
    return () => setSearchTerm("");
  }, [isVisible]);
  return {
    handleInputChange,
    searchTerm,
    searchUrl: `${baseUrl}/search`
  };
};
const useCustomScrollTrigger = () => {
  const [isSystemScroll, setIsSystemScroll] = useState(false);
  const [userInteraction, setUserInteraction] = useState(false);
  const muiTrigger = useScrollTrigger();
  const enableSystemScroll = useCallback((lastScrollPosition) => {
    setIsSystemScroll(true);
    setUserInteraction(false);
    const handleScrollCheck = () => {
      if (window && window.scrollY === lastScrollPosition) {
        window.removeEventListener("scroll", handleScrollCheck);
        setTimeout(() => {
          setIsSystemScroll(false);
        }, 100);
      }
    };
    window.addEventListener("scroll", handleScrollCheck);
  }, []);
  useEffect(() => {
    if (window && !isSystemScroll) {
      const handleUserScroll = () => {
        setUserInteraction(true);
        window.removeEventListener("scroll", handleUserScroll);
      };
      window.addEventListener("scroll", handleUserScroll);
      return () => {
        window.removeEventListener("scroll", handleUserScroll);
      };
    }
  }, [isSystemScroll]);
  const trigger = !muiTrigger || isSystemScroll || !userInteraction;
  return {
    trigger,
    enableSystemScroll
  };
};
forwardRef(({ to, ...props }, ref) => /* @__PURE__ */ jsx("a", { id: "MockGatsbyLink", ref, href: to, ...props }));
forwardRef(({ href, ...props }, ref) => /* @__PURE__ */ jsx("a", { id: "MockNextLink", ref, href, ...props }));
const mockSkeletonNavBar = [
  {
    variant: SKELETON_VARIANTS.ROUNDED,
    width: 100,
    height: 37,
    sx: { reverseAnimation: true }
  },
  {
    variant: SKELETON_VARIANTS.ROUNDED,
    width: 99,
    height: 37
  },
  {
    variant: SKELETON_VARIANTS.ROUNDED,
    width: 82,
    height: 37,
    sx: { reverseAnimation: true }
  },
  {
    variant: SKELETON_VARIANTS.ROUNDED,
    width: 100,
    height: 37
  },
  {
    variant: SKELETON_VARIANTS.ROUNDED,
    width: 122,
    height: 37,
    sx: { reverseAnimation: true }
  },
  {
    variant: SKELETON_VARIANTS.ROUNDED,
    width: 93,
    height: 37
  }
];
const mockSkeletonSearchCTA = [
  {
    variant: SKELETON_VARIANTS.ROUNDED_RECT,
    width: 132,
    height: 48,
    sx: { reverseAnimation: true }
  },
  {
    variant: SKELETON_VARIANTS.ROUNDED_RECT,
    width: 138,
    height: 48
  }
];
const ribbonHeight = {
  desktop: "88px",
  mobile: "70px"
};
const getHeight = (isDesktopLayout) => isDesktopLayout ? ribbonHeight.desktop : ribbonHeight.mobile;
const StyledRibbonContainer = styled$1(Box, {
  shouldForwardProp: (prop) => prop !== "isClient" && prop !== "isDesktopLayout"
})(({ theme, isClient, isDesktopLayout }) => {
  var _a, _b;
  return {
    position: "fixed",
    width: "100vw",
    top: 0,
    zIndex: ((_b = (_a = theme.vars) == null ? void 0 : _a.zIndex) == null ? void 0 : _b.ribbon) ?? 1250,
    visibility: isClient ? "visible" : "hidden",
    minHeight: getHeight(isDesktopLayout),
    "& .header-strip-container-desktop": {
      [theme.breakpoints.down(theme.breakpoints.values.xl)]: {
        visibility: "hidden"
      }
    },
    "& .header-strip-container-mobile": {
      [theme.breakpoints.up(theme.breakpoints.values.xl)]: {
        visibility: "hidden"
      }
    }
  };
});
const StyledMobileAppBar = styled$1(AppBar, {
  shouldForwardProp: (prop) => prop !== "isDrawerOpen" && prop !== "isSearchBarOpen"
})(({ theme, isDrawerOpen, isSearchBarOpen }) => {
  var _a, _b, _c;
  return {
    padding: "20px 16px",
    backgroundColor: (_a = theme.vars.palette.grey) == null ? void 0 : _a[0],
    color: "black",
    boxShadow: (_b = theme.vars.shadows) == null ? void 0 : _b[2],
    position: "relative",
    zIndex: `calc(11 + ${theme.vars.zIndex.drawer})`,
    borderBottom: isDrawerOpen ? `1px solid ${(_c = theme.vars.palette.grey) == null ? void 0 : _c[20]}` : "none",
    boxShadow: isSearchBarOpen ? "none" : `${theme.vars.shadows[2]}`,
    "& .MuiToolbar-root": {
      boxSizing: "border-box",
      display: "flex",
      gap: "16px",
      minHeight: "30px",
      maxHeight: "30px",
      padding: "0px",
      maxWidth: "100%"
    }
  };
});
const StyledDesktopAppBar = styled$1(AppBar)(
  ({ theme }) => {
    var _a, _b;
    const { xl, xxl } = theme.breakpoints.contentGrids;
    return {
      padding: "20px 0px",
      backgroundColor: (_a = theme.vars.palette.grey) == null ? void 0 : _a[0],
      color: "black",
      boxShadow: (_b = theme.vars.shadows) == null ? void 0 : _b[2],
      position: "relative",
      zIndex: `calc(11 + ${theme.vars.zIndex.drawer})`,
      maxHeight: ribbonHeight.desktop,
      "& .MuiToolbar-root": {
        boxSizing: "border-box",
        display: "flex",
        gap: "16px",
        justifyContent: "space-between",
        minHeight: "40px",
        padding: "0px",
        width: "100%",
        margin: "0 auto",
        [theme.breakpoints.up(theme.breakpoints.values.xl)]: {
          maxWidth: xl.columns.full
        },
        [theme.breakpoints.up(theme.breakpoints.values.xxl)]: {
          maxWidth: xxl.columns.full,
          gap: "24px"
        }
      }
    };
  }
);
const StyledContainer = styled$1(Box)({
  display: "flex"
});
const MobileRibbonLayout = ({
  ribbonRef
}) => {
  const {
    navigationLinkNodes,
    isTierOneNavOpen,
    isTierTwoNavOpen,
    isSearchBarOpen,
    handleNavBarClick
  } = useContext(GlobalHeadContext);
  const { trigger, enableSystemScroll } = useCustomScrollTrigger();
  const [tier2Nodes, setTier2Nodes] = useState([]);
  const [tier2MenuTitle, setTier2MenuTitle] = useState("");
  const [lastScrollY, setLastScrollY] = useState(0);
  const isDrawerOpen = isTierOneNavOpen || isTierTwoNavOpen;
  useEffect(() => clearBodyNoScroll);
  useEffect(() => {
    ribbonRef.current.style.pointerEvents = trigger ? "" : "none";
  }, [trigger]);
  const handleHamburgerClick = () => {
    if (isDrawerOpen) {
      enableSystemScroll(lastScrollY);
      handleNavBarClick(NAVIGATION_BAR_ACTIONS.CLOSE_ALL);
      return;
    }
    if (window) {
      setLastScrollY(window.scrollY);
    }
    handleNavBarClick(NAVIGATION_BAR_ACTIONS.TIER_1, true);
  };
  const handleOpenTier2 = (node) => {
    var _a;
    setLastScrollY(lastScrollY);
    setTier2Nodes(((_a = node == null ? void 0 : node.childItems) == null ? void 0 : _a.nodes) ?? []);
    setTier2MenuTitle(node == null ? void 0 : node.label);
    handleNavBarClick(NAVIGATION_BAR_ACTIONS.TIER_2, true);
  };
  const handleGoBackToTier1 = () => {
    handleNavBarClick(NAVIGATION_BAR_ACTIONS.TIER_1, true);
  };
  const navBarProps = {
    onClose: () => {
      handleNavBarClick(NAVIGATION_BAR_ACTIONS.CLOSE_ALL);
      enableSystemScroll(lastScrollY);
    }
  };
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx(Slide, { appear: false, direction: "down", in: isDrawerOpen || trigger, children: /* @__PURE__ */ jsx(
      StyledMobileAppBar,
      {
        "data-testid": "header-bar",
        isDrawerOpen,
        isSearchBarOpen,
        children: /* @__PURE__ */ jsxs(Toolbar, { className: "header-strip-container-mobile", "data-testid": "mobile-header-strip-container", children: [
          /* @__PURE__ */ jsx(StyledContainer, { "data-testid": "mobile-menu-icons", children: /* @__PURE__ */ jsx(
            HamburgerButton,
            {
              isOpen: isDrawerOpen,
              onClick: handleHamburgerClick
            }
          ) }),
          /* @__PURE__ */ jsx(StyledContainer, { id: "mobile-ql-logo", "data-testid": "mobile-ql-logo", children: /* @__PURE__ */ jsx(Logo, {}) }),
          /* @__PURE__ */ jsx(StyledContainer, { "data-testid": "mobile-cta-and-search", style: { marginLeft: "auto" }, children: /* @__PURE__ */ jsx(
            SearchCTA,
            {
              isDesktop: false,
              ribbonRef,
              onOpenSearchBar: () => setLastScrollY(window.scrollY),
              onCloseSearchBar: () => () => enableSystemScroll(lastScrollY)
            }
          ) })
        ] })
      }
    ) }),
    /* @__PURE__ */ jsx(
      NavigationBarMobile,
      {
        isVisible: isTierOneNavOpen,
        navigationLinkNodes,
        isTier2: false,
        navBarProps,
        ribbonParentRef: ribbonRef,
        handleClickOnSubNavLink: (node) => handleOpenTier2(node)
      }
    ),
    /* @__PURE__ */ jsx(
      NavigationBarMobile,
      {
        isVisible: isTierTwoNavOpen,
        navigationLinkNodes: tier2Nodes,
        isTier2: true,
        navBarProps,
        ribbonParentRef: ribbonRef,
        handleGoBackToTier1,
        menuTitle: tier2MenuTitle
      }
    )
  ] });
};
MobileRibbonLayout.propTypes = {
  ribbonRef: PropTypes.object.isRequired
};
const StyledMenuDrawer = ({ isAccountMenu, children, ...rest }) => /* @__PURE__ */ jsx(Drawer, { ...rest, children });
const StyledDrawer$2 = styled$1(StyledMenuDrawer)(
  ({ theme, isAccountMenu }) => {
    return `
            display: none;
            ${theme.breakpoints.up(BREAKPOINT_DIMENSIONS.extra_large)} {
                display: contents;
            }
            .MuiPaper-root {
                width: 100%;
                height: ${isAccountMenu ? "407px" : "auto"};
                padding: 4px 0 ${isAccountMenu ? 20 : 36}px;
                box-shadow: ${theme.vars.shadows[2]};
            }
            .EndemicContentContainer {
                height: 355px; 
                width: 227px;
                display: flex;
                justify-content: center;
                align-items: center;
                text-align: center;
                flex-direction: column;
                h5 {
                    margin-top: 11px;
                }
                img {
                    width: 140px;
                }
            }
        `;
  }
);
const StyledDrawerBox = ({ isAccountMenu, children, ...rest }) => /* @__PURE__ */ jsx("nav", { itemScope: !isAccountMenu ? true : null, itemType: !isAccountMenu ? "https://schema.org/SiteNavigationElement" : null, ...rest, children });
const StyledBox = styled$1(StyledDrawerBox)(
  ({ theme, isAccountMenu }) => {
    const { link } = theme["global-head"].nav.desktop;
    const xl = theme.breakpoints.contentGrids[BREAKPOINT_DIMENSIONS.extra_large];
    const xxl = theme.breakpoints.contentGrids[BREAKPOINT_DIMENSIONS.extra_extra_large];
    return `
            ${theme.breakpoints.up(BREAKPOINT_DIMENSIONS.extra_large)} {
                display: flex;
                flex-direction: column;
                flex-wrap: wrap;
                column-gap: ${xl.columns.gutter};
                align-items: flex-start;
                place-content: flex-start;
                max-height: calc(6 * (${link.height}px + ${isAccountMenu ? 1.6 : 1}rem));
                width: ${xl.columns.full};
                text-align: left;
                margin: 0 auto;
                animation: navBoxReveal 600ms ease-out forwards;

                @keyframes navBoxReveal {
                    from {
                        opacity: 0;
                    }
                    to {
                        opacity: 1;
                    }
                }
            }
            ${theme.breakpoints.up(BREAKPOINT_DIMENSIONS.extra_extra_large)} {
                width: ${xxl.columns.full};
                column-gap: ${xxl.columns.gutter};
            }
        `;
  }
);
const StyledNavContainer = styled$1("div")(
  ({ theme }) => {
    const xl = theme.breakpoints.contentGrids[BREAKPOINT_DIMENSIONS.extra_large];
    const xxl = theme.breakpoints.contentGrids[BREAKPOINT_DIMENSIONS.extra_extra_large];
    return `
            display: flex;
            flex-direction: column;
            align-items: flex-start;
            width: ${xl.columns[3]};
            ${theme.breakpoints.up(BREAKPOINT_DIMENSIONS.extra_extra_large)} {
                width: ${xxl.columns[3]};
            }
        `;
  }
);
const StyledNavigationLink = styled$1(NavigationLink)(
  ({ theme }) => {
    return `
        width: auto;    
        margin-bottom: 1rem;
        `;
  }
);
const classNames = {
  NAV_LINK_CONTAINER: "nav-link-container",
  NAV_BAR_DESKTOP: "nav-bar-desktop"
};
const testIds = {
  ...classNames
};
const renderLink = (node) => {
  var _a;
  return /* @__PURE__ */ jsx(
    StyledNavigationLink,
    {
      title: node.label,
      href: node.url,
      isForMainNav: false,
      icon: ((_a = node.url) == null ? void 0 : _a.includes("/logout")) ? /* @__PURE__ */ jsx(LogoutOutlined, {}) : null
    },
    `grpNav${node.databaseId}`
  );
};
const renderContainer = (containedLinks, containerKey) => /* @__PURE__ */ jsx(
  StyledNavContainer,
  {
    className: classNames.NAV_LINK_CONTAINER,
    "data-testid": testIds.NAV_LINK_CONTAINER,
    children: containedLinks
  },
  containerKey
);
const MegaMenuNavLinks = ({ navigationLinkNodes }) => {
  const nodes = [...navigationLinkNodes];
  let navLinkContainers = [];
  const linksModulo = navigationLinkNodes.length % 6;
  const hasOrphan = linksModulo === 1;
  const singleIndex = navigationLinkNodes.length - 7;
  for (let ix = 0; ix < nodes.length; ix++) {
    if (hasOrphan && ix === singleIndex) {
      navLinkContainers.push(renderContainer(
        [renderLink(nodes[ix])],
        "ctnNavSingleElement"
      ));
    } else {
      const containedNodes = nodes.slice(ix, ix + 2);
      ix++;
      const containedLinks = [];
      containedNodes.forEach((node) => {
        containedLinks.push(renderLink(node));
      });
      navLinkContainers.push(renderContainer(
        containedLinks,
        containedNodes.reduce((key, node) => `${key},${node.databaseId}`, "ctnNav")
      ));
    }
  }
  return /* @__PURE__ */ jsx(Fragment, { children: navLinkContainers });
};
MegaMenuNavLinks.propTypes = {
  navigationLinkNodes: PropTypes.arrayOf(PropTypes.object)
};
const EndemicContent = ({
  dataTestId,
  userName
}) => {
  return /* @__PURE__ */ jsxs(Box, { className: "EndemicContentContainer", children: [
    /* @__PURE__ */ jsx(
      "img",
      {
        src: "https://content.quickenloans.com/ql/brand/illustrations/Standing_-_Green.svg",
        alt: "Endemic Content Illustration",
        title: "Endemic Content Illustration",
        role: "img",
        "data-testid": `${dataTestId}-endemic-content-illustration`
      }
    ),
    /* @__PURE__ */ jsxs(Headline5, { "data-testid": `${dataTestId}-endemic-content-welcome-message`, className: "h5_bold", children: [
      "Welcome,",
      /* @__PURE__ */ jsx("br", {}),
      userName,
      "!"
    ] })
  ] });
};
EndemicContent.propTypes = {
  dataTestId: PropTypes.string.isRequired,
  userName: PropTypes.string.isRequired
};
const MegaMenu = ({
  isVisible,
  navigationLinkNodes = [],
  sx = {},
  navBarProps = {},
  ribbonParentRef,
  // @NOTE: ref of parent container for ribbon, should not have extra vert. height
  isAccountMenu = false,
  userName
}) => {
  const {
    paperProps,
    backdropProps,
    slideProps,
    modalProps
  } = getDrawerProps({
    ribbonParentRef,
    dataTestIdBackdrop: "nav-bar-backdrop"
  });
  const conditionalModalProps = {
    ...modalProps,
    keepMounted: !isAccountMenu
  };
  return /* @__PURE__ */ jsx(
    StyledDrawer$2,
    {
      open: isVisible,
      anchor: "top",
      transitionDuration: DRAWER_TRANSITION_DURATION_DESKTOP,
      sx,
      PaperProps: paperProps,
      BackdropProps: backdropProps,
      SlideProps: slideProps,
      ModalProps: conditionalModalProps,
      variant: "temporary",
      ...navBarProps,
      className: classNames.NAV_BAR_DESKTOP,
      "data-testid": testIds.NAV_BAR_DESKTOP,
      elevation: 5,
      isAccountMenu,
      children: /* @__PURE__ */ jsxs(StyledBox, { "data-testid": "nav-styled-box", isAccountMenu, children: [
        isAccountMenu && /* @__PURE__ */ jsxs(Fragment, { children: [
          /* @__PURE__ */ jsx(EndemicContent, { dataTestId: "mega-menu", userName }),
          /* @__PURE__ */ jsx(Divider, { orientation: "vertical" })
        ] }),
        /* @__PURE__ */ jsx(MegaMenuNavLinks, { navigationLinkNodes })
      ] })
    }
  );
};
MegaMenu.propTypes = {
  isVisible: PropTypes.bool,
  navigationLinkNodes: PropTypes.arrayOf(PropTypes.object),
  sx: PropTypes.object,
  navBarProps: PropTypes.object,
  ribbonParentRef: PropTypes.oneOfType([
    PropTypes.object,
    PropTypes.func
  ]),
  isAccountMenu: PropTypes.bool,
  userName: PropTypes.string
};
const StyledDesktopNavBar = styled(Box)({
  alignItems: "center",
  boxSizing: "border-box",
  display: "flex",
  flexDirection: "row",
  gap: "16px",
  justifyContent: "left",
  maxHeight: "37px",
  maxWidth: "742px",
  minWidth: "696px"
});
const StyledDrawer$1 = styled(Drawer)(({ theme }) => ({
  display: "contents",
  "& .MuiBackdrop-root": {
    zIndex: 0
  },
  "& .MuiPaper-root": {
    width: "287px",
    [theme.breakpoints.up(BREAKPOINT_DIMENSIONS.medium)]: {
      width: "352px",
      padding: "24px"
    },
    overflow: "auto",
    height: "100%",
    padding: "24px 8px",
    boxShadow: "none"
  }
}));
const Tier1Container = styled(Box)(({ theme }) => {
  var _a;
  return {
    "& .ButtonContainer": {
      display: "flex",
      justifyContent: "center",
      paddingTop: "8px",
      "& a": {
        height: "48px",
        minWidth: "255px",
        [theme.breakpoints.up(BREAKPOINT_DIMENSIONS.medium)]: {
          minWidth: "285px"
        }
      }
    },
    "& .EndemicContentContainer": {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      textAlign: "center",
      flexDirection: "column",
      "& img": {
        width: "79px"
      },
      "& h5": {
        margin: "8px 0px 16px"
      }
    },
    "& .MuiDivider-root": {
      marginBottom: "24px",
      borderColor: (_a = theme.vars.palette.grey) == null ? void 0 : _a[20]
    }
  };
});
const Tier2Container = styled(Box)(({ theme }) => {
  var _a, _b;
  return {
    "& .MuiToolbar-root": {
      display: "flex",
      padding: "0px 0px 16px",
      minHeight: "24px",
      cursor: "pointer",
      WebkitTapHighlightColor: "transparent",
      // Remove light blue hightlight on toolbar click 
      "& .MuiTypography-root": {
        textAlign: "center",
        flexGrow: "1",
        color: (_a = theme.vars.palette.grey) == null ? void 0 : _a[80],
        fontWeight: "600"
      }
    },
    "& .MuiDivider-root": {
      marginBottom: "24px",
      borderColor: (_b = theme.vars.palette.grey) == null ? void 0 : _b[20]
    }
  };
});
const IconContainer = styled(Box)(({ theme }) => {
  var _a;
  return {
    width: "24px",
    height: "24px",
    svg: {
      fill: (_a = theme.vars.palette.grey) == null ? void 0 : _a[80],
      width: "100%",
      height: "100%"
    }
  };
});
const NavigationBarMobile = ({
  isVisible,
  navigationLinkNodes = [],
  isTier2 = false,
  menuTitle = "",
  // Applies to Tier 2
  handleClickOnSubNavLink = (node) => {
  },
  handleGoBackToTier1 = () => {
  },
  // Applies to Tier 2
  sx = {},
  navBarProps = {},
  ribbonParentRef
  // @NOTE: ref of parent container for ribbon, should not have extra vert. height
}) => {
  const {
    environment: currentEnv,
    globalAccountLinks,
    isAuthenticated,
    userName
  } = useContext(GlobalHeadContext);
  const sourceIdHref = getEnvVariable({
    currentEnv,
    keyToSearch: "REFINANCE_BASE_URL"
  });
  const {
    paperProps,
    backdropProps,
    slideProps,
    modalProps
  } = getDrawerProps({
    ribbonParentRef,
    dataTestIdPaper: "nav-bar-mobile-paper",
    dataTestIdBackdrop: "nav-bar-mobile-backdrop",
    isMobile: true
  });
  const MyAccountMenuNode = {
    databaseId: 1158,
    label: "My Account",
    path: "#",
    url: "#",
    parentDatabaseId: 0,
    childItems: {
      nodes: globalAccountLinks
    }
  };
  const renderNavigationLinks = (navLinks, hasTier2 = false) => {
    return navLinks.map((node) => {
      var _a, _b, _c;
      const hasChildren = ((_b = (_a = node == null ? void 0 : node.childItems) == null ? void 0 : _a.nodes) == null ? void 0 : _b.length) > 0 || hasTier2;
      return /* @__PURE__ */ jsx(
        NavigationLink,
        {
          title: node.label,
          href: !hasChildren ? node.url : null,
          hasChildren,
          sx: { marginBottom: "16px" },
          isForMainNav: false,
          onClick: () => {
            if (hasChildren) {
              handleClickOnSubNavLink(node);
            }
          },
          icon: ((_c = node.url) == null ? void 0 : _c.includes("/logout")) ? /* @__PURE__ */ jsx(LogoutOutlined, {}) : null
        },
        `${isTier2 ? "tier-2" : "tier-1"}-${node.databaseId}`
      );
    });
  };
  const mobileModalProps = {
    ...modalProps,
    keepMounted: false
  };
  return /* @__PURE__ */ jsx(
    StyledDrawer$1,
    {
      open: isVisible,
      sx,
      ...navBarProps,
      "data-testid": "nav-bar-mobile",
      PaperProps: paperProps,
      BackdropProps: backdropProps,
      SlideProps: slideProps,
      ModalProps: mobileModalProps,
      transitionDuration: DRAWER_TRANSITION_DURATION,
      elevation: 5,
      children: isTier2 ? /* @__PURE__ */ jsxs(Tier2Container, { children: [
        /* @__PURE__ */ jsxs(
          Toolbar,
          {
            id: "nav-bar-mobile-header",
            onClick: handleGoBackToTier1,
            onKeyDown: (event) => {
              if (event.key === "Enter") {
                event.preventDefault();
                handleGoBackToTier1();
              }
            },
            children: [
              /* @__PURE__ */ jsx(IconContainer, { "data-testid": "nav-bar-mobile-header-icon", children: /* @__PURE__ */ jsx(NavigateBefore, {}) }),
              /* @__PURE__ */ jsx(Typography, { "data-testid": "nav-bar-mobile-header-text", children: menuTitle }),
              /* @__PURE__ */ jsx(IconContainer, { children: /* @__PURE__ */ jsx(NavigateBefore, { style: { visibility: "hidden" } }) })
            ]
          }
        ),
        /* @__PURE__ */ jsx(Divider, {}),
        /* @__PURE__ */ jsx(Box, { children: renderNavigationLinks(navigationLinkNodes) })
      ] }) : /* @__PURE__ */ jsxs(Tier1Container, { children: [
        isAuthenticated && /* @__PURE__ */ jsxs(Fragment, { children: [
          /* @__PURE__ */ jsx(EndemicContent, { dataTestId: "nav-bar-mobile", userName }),
          renderNavigationLinks([MyAccountMenuNode], true),
          /* @__PURE__ */ jsx(Divider, {})
        ] }),
        renderNavigationLinks(navigationLinkNodes),
        /* @__PURE__ */ jsx(Box, { className: "ButtonContainer", children: /* @__PURE__ */ jsx(
          SourceIdLink,
          {
            href: sourceIdHref,
            target: "_blank",
            "aria-label": ARIA_LABELS.GET_STARTED,
            "data-testid": "nav-bar-mobile-get-started-button",
            children: LABELS.GET_STARTED
          }
        ) })
      ] })
    }
  );
};
NavigationBarMobile.propTypes = {
  isVisible: PropTypes.bool.isRequired,
  navigationLinkNodes: PropTypes.arrayOf(PropTypes.object),
  isTier2: PropTypes.bool,
  menuTitle: PropTypes.string,
  handleClickOnSubNavLink: PropTypes.func,
  handleGoBackToTier1: PropTypes.func,
  sx: PropTypes.object,
  navBarProps: PropTypes.object
};
const NavigationBarDesktop = ({
  isVisible = false,
  navLinkSx = {},
  ribbonRef = {},
  sx = {}
}) => {
  if (!isVisible) {
    return null;
  }
  const {
    handleMyAccountMenuClick,
    handleNavBarClick,
    isDesktop,
    isMenuLoading,
    isTierOneNavOpen,
    navigationLinkNodes
  } = useContext(GlobalHeadContext);
  const [navigationLinkOpen, setNavigationLinkOpen] = useState(-1);
  const handleClick = (event, databaseId) => {
    var _a, _b;
    if (((_b = (_a = event == null ? void 0 : event.target) == null ? void 0 : _a.tagName) == null ? void 0 : _b.toLowerCase()) === "a") {
      event.preventDefault();
      setNavigationLinkOpen(-1);
      return;
    }
    const isSameLink = databaseId === navigationLinkOpen;
    setNavigationLinkOpen(isSameLink ? -1 : databaseId);
    handleNavBarClick(NAVIGATION_BAR_ACTIONS.TIER_1, !isSameLink);
  };
  const navBarProps = {
    onClose: () => {
      setNavigationLinkOpen(-1);
      handleNavBarClick(NAVIGATION_BAR_ACTIONS.TIER_1, false);
    }
  };
  const shouldRenderSkeleton = isMenuLoading || !isMenuLoading && !navigationLinkNodes.length;
  useEffect(() => {
    if (!isTierOneNavOpen && navigationLinkOpen !== -1) {
      setNavigationLinkOpen(-1);
    }
  }, [isTierOneNavOpen, navigationLinkOpen]);
  useEffect(() => {
    if (!isDesktop) {
      navBarProps.onClose();
      handleMyAccountMenuClick(false);
    }
  }, [isDesktop]);
  return /* @__PURE__ */ jsx(StyledDesktopNavBar, { "data-testid": "desktop-nav-bar", sx, itemScope: true, itemType: "https://schema.org/SiteNavigationElement", children: shouldRenderSkeleton ? /* @__PURE__ */ jsx(SkeletonNavBarDesktop, {}) : navigationLinkNodes.map(({ childItems, databaseId, label, url }) => {
    var _a;
    const hasChildren = childItems && ((_a = childItems == null ? void 0 : childItems.nodes) == null ? void 0 : _a.length);
    const isNavigationLinkActive = isTierOneNavOpen && navigationLinkOpen === databaseId;
    return /* @__PURE__ */ jsxs("div", { "data-testid": `desktop-nav-bar-megamenu-container-${databaseId}`, children: [
      /* @__PURE__ */ jsx(
        NavigationLink,
        {
          href: hasChildren ? "#" : url,
          isActive: isNavigationLinkActive,
          sx: navLinkSx,
          title: label,
          onClick: (event) => handleClick(event, databaseId)
        }
      ),
      // Validation added to prevent unwanted behavior when clicking anchor tags
      isDesktop && hasChildren ? /* @__PURE__ */ jsx(
        MegaMenu,
        {
          isVisible: isNavigationLinkActive,
          navBarProps,
          navigationLinkNodes: (childItems == null ? void 0 : childItems.nodes) ?? [],
          ribbonParentRef: ribbonRef
        }
      ) : null
    ] }, databaseId);
  }) });
};
NavigationBarDesktop.propTypes = {
  isVisible: PropTypes.bool.isRequired,
  navLinkSx: PropTypes.object,
  ribbonRef: PropTypes.object,
  sx: PropTypes.object
};
const fontWeightSemibold = "var(--font-weight-semibold)", focusBgColor = "var(--color-primary-110)";
const SearchCTAContainer = styled$1(Box)(
  ({ theme }) => {
    return {
      display: "flex",
      alignItems: "center",
      gap: "8px",
      [theme.breakpoints.up("xxl")]: {
        gap: "16px"
      },
      "& .get-started-button": {
        height: "48px",
        width: "144px"
      }
    };
  }
);
const AccountButton = styled$1(Button)(
  ({ theme }) => {
    var _a;
    return {
      cursor: "pointer",
      fontFamily: theme.typography.fontFamily,
      fontWeight: fontWeightSemibold,
      border: 0,
      "&:focus": {
        "& svg": {
          transform: "rotate(-180deg)"
        }
      },
      "&.active": {
        backgroundColor: (_a = theme.vars.palette.primary) == null ? void 0 : _a[10],
        color: focusBgColor,
        "& svg": {
          fill: focusBgColor
        }
      },
      "& svg": {
        transition: "transform 0.3s ease"
      },
      "&:focus-visible": {
        outline: "auto 1px black"
      }
    };
  }
);
const SignInButton = styled$1(BYOButton)(
  ({ theme }) => {
    var _a, _b;
    return {
      cursor: "pointer",
      fontFamily: theme.typography.fontFamily,
      fontWeight: fontWeightSemibold,
      height: "48px",
      border: 0,
      "&:focus-visible": {
        outline: "auto 1px black"
      },
      "&:hover": {
        // Prevent error icon from turning blue on button hover
        ".MuiSvgIcon-root": {
          fill: (_a = theme.vars.palette.warning) == null ? void 0 : _a[90]
        }
      },
      ".MuiSvgIcon-root": {
        fill: (_b = theme.vars.palette.warning) == null ? void 0 : _b[90]
      }
    };
  }
);
const SearchCTA = ({
  isDesktop,
  ribbonRef = {},
  onOpenSearchBar = () => {
  },
  onCloseSearchBar = () => {
  }
}) => {
  const {
    environment: currentEnv,
    globalAccountLinks,
    handleMyAccountMenuClick,
    handleSearchBarClick,
    isAuthenticated,
    isMyAccountMenuOpen,
    isSearchBarOpen,
    isUserDataLoading,
    userDataError,
    userName
  } = useContext(GlobalHeadContext);
  const sourceIdHref = getEnvVariable({
    currentEnv,
    keyToSearch: "REFINANCE_BASE_URL"
  });
  const signInHref = getEnvVariable({
    currentEnv,
    keyToSearch: "AUTH0_LOGIN_URL"
  });
  const searchBarProps = {
    onClose: () => {
      handleSearchBarClick(false);
      onCloseSearchBar();
      setTimeout(() => {
        document.getElementById("SearchIconButton").focus();
      }, 100);
    }
  };
  const myAccountMenuProps = {
    onClose: () => {
      handleMyAccountMenuClick(false);
      setTimeout(() => {
        document.getElementById("search-cta-account-button").focus();
      }, 100);
    }
  };
  const SourceIdButton = () => /* @__PURE__ */ jsx(
    SourceIdLink,
    {
      className: "get-started-button",
      href: sourceIdHref,
      target: "_blank",
      "aria-label": ARIA_LABELS.GET_STARTED,
      "data-testid": "search-cta-get-started-button",
      id: "search-cta-get-started-button",
      children: LABELS.GET_STARTED
    }
  );
  const DesktopCTAButtonState = () => {
    if (isUserDataLoading) {
      return /* @__PURE__ */ jsx(SkeletonSearchCTADesktop, {});
    }
    if (isAuthenticated) {
      return /* @__PURE__ */ jsxs(Fragment, { children: [
        /* @__PURE__ */ jsx(
          AccountButton,
          {
            style: "outlined",
            color: "blue",
            onClick: () => handleMyAccountMenuClick(!isMyAccountMenuOpen),
            "data-testid": "search-cta-account-button",
            id: "search-cta-account-button",
            iconRight: isMyAccountMenuOpen ? /* @__PURE__ */ jsx(KeyboardArrowUpOutlined, {}) : /* @__PURE__ */ jsx(KeyboardArrowDownOutlined, {}),
            "aria-label": ARIA_LABELS.MY_ACCOUNT,
            role: "button",
            className: isMyAccountMenuOpen ? "active" : "",
            children: LABELS.MY_ACCOUNT
          }
        ),
        /* @__PURE__ */ jsx(SourceIdButton, {})
      ] });
    }
    return /* @__PURE__ */ jsxs(Fragment, { children: [
      /* @__PURE__ */ jsx(
        SignInButton,
        {
          style: "outlined",
          color: "blue",
          href: signInHref,
          "data-testid": "search-cta-sign-in-button",
          id: "search-cta-sign-in-button",
          "aria-label": ARIA_LABELS.SIGN_IN_JOIN,
          iconLeft: userDataError ? /* @__PURE__ */ jsx(ErrorIcon, {}) : null,
          children: LABELS.SIGN_IN_JOIN
        }
      ),
      /* @__PURE__ */ jsx(SourceIdButton, {})
    ] });
  };
  const MobileAccountButtonState = () => {
    if (isUserDataLoading) {
      return /* @__PURE__ */ jsx(SkeletonSearchCTADesktop, { skeletonMock: [mockSkeletonSearchCTA[0]] });
    }
    if (isAuthenticated) {
      return null;
    }
    return /* @__PURE__ */ jsx(
      SignInButton,
      {
        sx: { padding: "13.5px 16px" },
        style: "outlined",
        color: "blue",
        href: signInHref,
        "data-testid": "search-cta-mobile-sign-in-button",
        id: "search-cta-mobile-sign-in-button",
        "aria-label": ARIA_LABELS.SIGN_IN_JOIN,
        iconLeft: userDataError ? /* @__PURE__ */ jsx(ErrorIcon, {}) : null,
        children: LABELS.SIGN_IN_JOIN
      }
    );
  };
  const handleMobileSearchBarClick = () => {
    const isNewStatusOpen = !isSearchBarOpen;
    const handleTriggerBehavior = isNewStatusOpen ? onOpenSearchBar : onCloseSearchBar;
    handleTriggerBehavior();
    handleSearchBarClick(isNewStatusOpen);
  };
  const MobileSearchCTALayout = () => /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx(MobileAccountButtonState, {}),
    /* @__PURE__ */ jsx(SearchIcon, { onClick: handleMobileSearchBarClick, isActive: isSearchBarOpen })
  ] });
  const DesktopSearchCTALayout = () => /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx(SearchIcon, { onClick: () => handleSearchBarClick(!isSearchBarOpen), isActive: isSearchBarOpen }),
    /* @__PURE__ */ jsx(DesktopCTAButtonState, {})
  ] });
  return /* @__PURE__ */ jsxs(SearchCTAContainer, { "data-testid": "search-cta-container", role: "navigation", "aria-label": "Search call-to-action", children: [
    /* @__PURE__ */ jsx(
      MegaMenu,
      {
        isVisible: isAuthenticated && isMyAccountMenuOpen,
        navBarProps: myAccountMenuProps,
        navigationLinkNodes: globalAccountLinks,
        ribbonParentRef: ribbonRef,
        isAccountMenu: true,
        userName
      }
    ),
    isDesktop ? /* @__PURE__ */ jsxs(Fragment, { children: [
      /* @__PURE__ */ jsx(DesktopSearchCTALayout, {}),
      /* @__PURE__ */ jsx(
        SearchBarDesktop,
        {
          isVisible: isSearchBarOpen,
          searchBarProps,
          ribbonParentRef: ribbonRef
        }
      )
    ] }) : /* @__PURE__ */ jsxs(Fragment, { children: [
      /* @__PURE__ */ jsx(MobileSearchCTALayout, {}),
      /* @__PURE__ */ jsx(
        SearchBarMobile,
        {
          isVisible: isSearchBarOpen,
          searchBarProps,
          ribbonParentRef: ribbonRef
        }
      )
    ] })
  ] });
};
SearchCTA.propTypes = {
  isDesktop: PropTypes.bool.isRequired,
  ribbonRef: PropTypes.oneOfType([
    PropTypes.object,
    PropTypes.func
  ]),
  onOpenSearchBar: PropTypes.func,
  onCloseSearchBar: PropTypes.func
};
const StyledSkeletonNavBarDesktop = styled$1(Box)(
  () => {
    return `
        opacity: 0;    
        animation: navSkeletonDelay 100ms linear 333ms forwards;
            @keyframes navSkeletonDelay {
                0% {
                    opacity: 0;
                },
                100% {
                    opacity: 1
                }
            }
        `;
  }
);
const SkeletonNavBarDesktop = () => {
  return /* @__PURE__ */ jsx(StyledSkeletonNavBarDesktop, { "data-testid": "skeleton-container", sx: { display: "flex", gap: "24px" }, children: mockSkeletonNavBar.map((option, index) => /* @__PURE__ */ jsx(Skeleton, { ...option }, `SkeletonNavBarDesktop-${index}`)) });
};
const SkeletonSearchCTADesktop = ({ skeletonMock = mockSkeletonSearchCTA }) => {
  return /* @__PURE__ */ jsx(Box, { "data-testid": "skeleton-cta-container", sx: { display: "flex", gap: "16px" }, children: skeletonMock.map((option, index) => /* @__PURE__ */ jsx(Skeleton, { ...option }, `SkeletonSearchCTADesktop-${index}`)) });
};
const StyledDrawer = styled$1(Drawer)(({ theme }) => ({
  display: "none",
  [theme.breakpoints.up(BREAKPOINT_DIMENSIONS.extra_large)]: {
    display: "contents"
  },
  "& .MuiPaper-root": {
    boxShadow: theme.vars.shadows[2],
    padding: "0 40px 20px 40px",
    alignItems: "center"
  }
}));
const SearchBarContainer = styled$1(Box)(
  ({ theme }) => {
    var _a, _b;
    return {
      display: "flex",
      flexDirection: "row",
      maxWidth: "1288px",
      width: "100%",
      padding: "24px 0px",
      "& .MuiBox-root": {
        flexShrink: 1,
        paddingRight: "16px",
        marginBottom: "0px",
        "& .MuiInputBase-root": {
          maxWidth: "100%",
          maxHeight: "48px",
          "& input": {
            width: "100%",
            "&::placeholder": {
              color: (_a = theme.vars.palette.grey) == null ? void 0 : _a[40]
            }
          },
          "& fieldset": {
            border: `1.5px solid ${(_b = theme.vars.palette.grey) == null ? void 0 : _b[50]}`
          }
        }
      },
      "& button": {
        marginLeft: "auto",
        maxHeight: "48px"
      }
    };
  }
);
const StyledButton = styled$1(Button)(
  ({ theme }) => {
    var _a;
    return {
      cursor: "pointer",
      fontFamily: (_a = theme == null ? void 0 : theme.typography) == null ? void 0 : _a.fontFamily,
      "&:focus-visible": {
        outline: "auto 1px black"
      }
    };
  }
);
const StyledDrawerMobile = styled$1(Drawer)({
  display: "contents",
  "& .MuiPaper-root": {
    boxShadow: "none",
    alignItems: "center"
  }
});
const SearchBarContainerMobile = styled$1(Box)(
  ({ theme }) => {
    var _a, _b;
    return {
      width: "100%",
      padding: "24px 16px",
      "& .MuiBox-root": {
        flexShrink: 1,
        paddingRight: "0px",
        marginBottom: "0px",
        "& .MuiInputBase-root": {
          maxWidth: "100%",
          maxHeight: "48px",
          "& input": {
            width: "100%",
            "&::placeholder": {
              color: (_a = theme.vars.palette.grey) == null ? void 0 : _a[40]
            }
          },
          "& fieldset": {
            border: `1.5px solid ${(_b = theme.vars.palette.grey) == null ? void 0 : _b[50]}`
          }
        }
      }
    };
  }
);
const StyledForm = styled$1("form")({
  display: "contents"
});
const SearchBarDesktop = ({
  isVisible,
  ribbonParentRef = {},
  sx = {},
  searchBarProps = {}
}) => {
  const { handleInputChange, searchTerm, searchUrl } = useSearchBar({ isVisible });
  const {
    paperProps,
    backdropProps,
    slideProps,
    modalProps
  } = getDrawerProps({
    ribbonParentRef,
    dataTestIdPaper: "search-bar-desktop-paper",
    dataTestIdBackdrop: "nav-bar-backdrop"
  });
  return /* @__PURE__ */ jsx(
    StyledDrawer,
    {
      open: isVisible,
      anchor: "top",
      "data-testid": "search-bar-desktop",
      transitionDuration: DRAWER_TRANSITION_DURATION,
      sx,
      ...searchBarProps,
      PaperProps: paperProps,
      BackdropProps: backdropProps,
      SlideProps: slideProps,
      ModalProps: modalProps,
      elevation: 5,
      children: /* @__PURE__ */ jsx(SearchBarContainer, { "data-testid": "search-bar-container", children: /* @__PURE__ */ jsxs(
        StyledForm,
        {
          action: searchUrl,
          "accept-charset": "utf-8",
          method: "get",
          children: [
            /* @__PURE__ */ jsx(
              TextField,
              {
                autoFocus: isVisible,
                "data-testid": "search-bar-input-text",
                icon: Search,
                inputProps: { maxLength: 255 },
                name: "q",
                onInputChange: handleInputChange,
                placeholder: LABELS.SEARCH_PLACEHOLDER,
                value: searchTerm
              }
            ),
            /* @__PURE__ */ jsx(
              StyledButton,
              {
                "data-testid": "search-button",
                style: "outlined",
                color: "blue",
                role: "button",
                type: "submit",
                children: LABELS.SEARCH
              }
            )
          ]
        }
      ) })
    }
  );
};
SearchBarDesktop.propTypes = {
  isVisible: PropTypes.bool,
  ribbonParentRef: PropTypes.oneOfType([
    PropTypes.object,
    PropTypes.func
  ]),
  sx: PropTypes.object,
  searchBarProps: PropTypes.object
};
const SearchBarMobile = ({
  isVisible,
  ribbonParentRef = {},
  sx = {},
  searchBarProps = {}
}) => {
  const { handleInputChange, searchTerm, searchUrl } = useSearchBar({ isVisible });
  const {
    paperProps,
    backdropProps,
    slideProps,
    modalProps
  } = getDrawerProps({
    ribbonParentRef,
    dataTestIdPaper: "search-bar-mobile-paper",
    dataTestIdBackdrop: "nav-bar-backdrop"
  });
  return /* @__PURE__ */ jsx(
    StyledDrawerMobile,
    {
      open: isVisible,
      anchor: "top",
      "data-testid": "search-bar-mobile",
      transitionDuration: DRAWER_TRANSITION_DURATION,
      sx,
      ...searchBarProps,
      PaperProps: paperProps,
      BackdropProps: backdropProps,
      SlideProps: slideProps,
      ModalProps: modalProps,
      elevation: 5,
      children: /* @__PURE__ */ jsx(SearchBarContainerMobile, { "data-testid": "search-bar-container", children: /* @__PURE__ */ jsx(
        StyledForm,
        {
          action: searchUrl,
          "accept-charset": "utf-8",
          method: "get",
          children: /* @__PURE__ */ jsx(
            TextField,
            {
              autoFocus: isVisible,
              "data-testid": "search-bar-input-text",
              icon: Search,
              inputProps: { maxLength: 255 },
              name: "q",
              onInputChange: handleInputChange,
              placeholder: LABELS.SEARCH_PLACEHOLDER,
              value: searchTerm
            }
          )
        }
      ) })
    }
  );
};
SearchBarMobile.propTypes = {
  isVisible: PropTypes.bool,
  ribbonParentRef: PropTypes.oneOfType([
    PropTypes.object,
    PropTypes.func
  ]),
  sx: PropTypes.object,
  searchBarProps: PropTypes.object
};
const OfferCardContainer = styled(Box)(({ theme }) => ({
  display: "flex",
  width: "1311px",
  height: "196px",
  alignItems: "center",
  gap: "16px",
  alignSelf: "stretch"
}));
const OfferCardLayout = styled(Box)(({ theme }) => ({
  display: "flex",
  padding: "32px 48px",
  justifyContent: "space-between",
  alignItems: "center",
  flex: "1 0 0",
  borderRadius: "8px",
  border: "1px solid #CCC",
  background: "#FFF"
}));
const CardHeader = styled(Box)(({ theme }) => ({
  display: "flex",
  width: "186px",
  height: "132px",
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "center",
  gap: "8px"
}));
const CardBody = styled(Box)(({ theme }) => ({
  display: "flex",
  height: "110px",
  alignItems: "center",
  gap: "112px"
}));
function OfferCard({
  sx = {},
  index = 0,
  offer,
  sourceId,
  marketingClickId
}) {
  return /* @__PURE__ */ jsx(OfferCardContainer, { sx, "data-testid": `offer-card-${offer.clientId}`, children: /* @__PURE__ */ jsxs(OfferCardLayout, { children: [
    /* @__PURE__ */ jsx(CardHeader, { children: /* @__PURE__ */ jsx(
      OfferLogo,
      {
        logoUrl: offer.logoUrl,
        clientId: offer.clientId,
        clientName: offer.clientName
      }
    ) }),
    /* @__PURE__ */ jsxs(CardBody, { children: [
      /* @__PURE__ */ jsx(
        Box,
        {
          sx: {
            width: "268px",
            height: "110px",
            display: "flex",
            paddingRight: "80px",
            flexDirection: "column",
            alignItems: "flex-start",
            gap: "16px",
            borderRight: "1px solid #E6E6E6"
          },
          children: /* @__PURE__ */ jsx(ProviderHighlights, { highlights: offer.highlights, clientId: offer.clientId })
        }
      ),
      /* @__PURE__ */ jsx(
        OfferCriteria,
        {
          criteria: offer.criteria,
          clientId: offer.clientId
        }
      )
    ] }),
    /* @__PURE__ */ jsx(
      OfferCta,
      {
        clientId: offer.clientId,
        clientName: offer.clientName,
        ctaButtonText: offer.ctaButtonText,
        ctaUrl: offer.ctaUrl,
        ctaAdditionalText: offer.ctaAdditionalText,
        sourceId,
        marketingClickId
      }
    )
  ] }) });
}
OfferCard.propTypes = {
  sx: PropTypes.object,
  index: PropTypes.number,
  offer: PropTypes.shape({
    clientId: PropTypes.string.isRequired,
    clientName: PropTypes.string.isRequired,
    logoUrl: PropTypes.string.isRequired,
    trustPilotUrl: PropTypes.oneOfType([() => null, PropTypes.string]),
    trustPilotBusinessId: PropTypes.oneOfType([() => null, PropTypes.string]),
    ctaButtonText: PropTypes.string.isRequired,
    ctaUrl: PropTypes.string.isRequired,
    ctaAdditionalText: PropTypes.string,
    highlights: PropTypes.arrayOf(PropTypes.string).isRequired,
    criteria: PropTypes.arrayOf(PropTypes.object).isRequired
  }).isRequired,
  sourceId: PropTypes.string.isRequired,
  marketingClickId: PropTypes.string.isRequired
};
const Ribbon = () => {
  const { isDesktop } = typeof window !== "undefined" ? useMediaQuery$1({}) : { isDesktop: () => true };
  const isHybrid = typeof window !== "undefined" ? useInRangeMediaQuery(HYBRID_BREAKPOINTS.MIN_WIDTH, HYBRID_BREAKPOINTS.MAX_WIDTH) : false;
  const isDesktopDevice = isDesktop();
  const ribbonRef = useRef(null);
  const [isClient, setIsClient] = useState(false);
  const [isDesktopLayout, setIsDesktopLayout] = useState(true);
  useEffect(() => {
    setIsClient(true);
  }, []);
  useEffect(
    () => {
      setIsDesktopLayout(isDesktopDevice);
    },
    [isDesktopDevice]
  );
  const DesktopRibbonLayout = () => {
    useEffect(() => clearBodyNoScroll);
    return /* @__PURE__ */ jsx(StyledDesktopAppBar, { "data-testid": "header-bar", children: /* @__PURE__ */ jsxs(Toolbar, { className: "header-strip-container-desktop", "data-testid": "header-strip-container", children: [
      /* @__PURE__ */ jsx(StyledContainer, { "data-testid": "ql-logo", children: /* @__PURE__ */ jsx(
        Logo,
        {
          showLarge: !isHybrid || !isClient,
          sx: { maxWidth: "138px", maxHeight: "38px", ...isClient && !isHybrid ? { width: "138px" } : {} }
        }
      ) }),
      /* @__PURE__ */ jsx(StyledContainer, { "data-testid": "navigation-links", children: /* @__PURE__ */ jsx(NavigationBarDesktop, { isVisible: true, ribbonRef }) }),
      /* @__PURE__ */ jsx(StyledContainer, { "data-testid": "cta-and-search", children: /* @__PURE__ */ jsx(
        SearchCTA,
        {
          isDesktop: true,
          ribbonRef,
          sx: { marginLeft: "0px" }
        }
      ) })
    ] }) });
  };
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx(StyledRibbonContainer, { id: "ribbon-container", ref: ribbonRef, isClient, isDesktopLayout, children: isDesktopLayout ? /* @__PURE__ */ jsx(DesktopRibbonLayout, {}) : /* @__PURE__ */ jsx(
      MobileRibbonLayout,
      {
        ribbonRef
      }
    ) }),
    /* @__PURE__ */ jsx(MenuSchema, {})
  ] });
};
const ENVIRONMENTS = {
  DEVELOPMENT: "development",
  PRODUCTION: "production",
  QA: "qa"
};
const useFetchMenu = ({ environment }) => {
  const [isMenuLoading, setIsMenuLoading] = useState(true);
  const [menuError, setMenuError] = useState(null);
  const [menuData, setMenuData] = useState(AppContextDefaults.menuData);
  useEffect(() => {
    if (!window) return;
    const controller = new AbortController();
    const signal = controller.signal;
    fetchMenu(environment, signal, setMenuData, setMenuError, setIsMenuLoading);
    return () => controller.abort();
  }, []);
  return { isMenuLoading, menuError, menuData };
};
const fetchMenu = async (environment, signal, setMenuData, setMenuError, setIsMenuLoading) => {
  var _a, _b;
  try {
    const bffApiUrl = getEnvVariable({ currentEnv: environment, keyToSearch: "BFF_API_URL" });
    const res = await window.fetch(`${bffApiUrl}/content/v1/main-menu`, { signal });
    if (!res.ok) throw new Error(`Error: ${res.statusText}`);
    const bffResponse = await res.json();
    const globalNav = ((_a = bffResponse == null ? void 0 : bffResponse.globalNav) == null ? void 0 : _a.nodes) ?? [];
    const globalAccount = ((_b = bffResponse == null ? void 0 : bffResponse.globalAccount) == null ? void 0 : _b.nodes) ?? [];
    if (Array.isArray(globalNav) && Array.isArray(globalAccount)) {
      setMenuData({
        globalNav,
        globalAccount
      });
      return;
    }
    throw new Error(`BFF response does not match the expected response: ${bffResponse}`);
  } catch (err) {
    handleError$1(err, setMenuError);
  } finally {
    setIsMenuLoading(false);
  }
};
const handleError$1 = (err, setMenuError) => {
  if (err.name !== "AbortError") {
    setMenuError(err.message);
    console.error("Something went wrong getting the bff menu:", { err });
  }
};
const useFetchUserData = ({ environment, setIsAuthenticated }) => {
  const [cookies] = useCookies([USER_SESSION_COOKIE], { doNotParse: true });
  const [isUserDataLoading, setIsUserDataLoading] = useState(true);
  const [userDataError, setUserDataError] = useState(null);
  const [userData, setUserData] = useState(null);
  const userSession = (cookies == null ? void 0 : cookies.userSession) ?? null;
  useEffect(() => {
    if (!window || !userSession) {
      setIsUserDataLoading(false);
      return;
    }
    const controller = new AbortController();
    const signal = controller.signal;
    fetchUserData({
      environment,
      setIsAuthenticated,
      setIsUserDataLoading,
      setUserData,
      setUserDataError,
      signal,
      userSession
    });
    return () => controller.abort();
  }, [userSession]);
  return { isUserDataLoading, userDataError, userData, setUserDataError };
};
const fetchUserData = async ({
  environment,
  setIsAuthenticated,
  setIsUserDataLoading,
  setUserData,
  setUserDataError,
  signal,
  userSession
}) => {
  try {
    const bffApiUrl = getEnvVariable({ currentEnv: environment, keyToSearch: "BFF_API_USER_DATA_URL" });
    const res = await window.fetch(
      bffApiUrl,
      {
        signal,
        headers: {
          Authorization: `Bearer ${userSession}`
        }
      }
    );
    if (res.ok) {
      const bffResponse = await res.json();
      if (!(bffResponse == null ? void 0 : bffResponse.userData)) {
        throw new Error(`UserData is not present in the response: ${bffResponse}`);
      }
      setUserData(bffResponse.userData);
      setIsAuthenticated(true);
      setUserDataError(null);
    }
    return;
  } catch (err) {
    handleError(err, setUserDataError);
  } finally {
    setIsUserDataLoading(false);
  }
};
const handleError = (err, setUserDataError) => {
  if (err.name !== "AbortError") {
    setUserDataError(err.message);
    console.error("Something went wrong getting the user data:", { err });
  }
};
const GlobalHeadProvider = ({
  children,
  environment,
  hostPlatform,
  LinkComponent = "a",
  uat = false
}) => {
  var _a;
  if (!hostPlatform) {
    throw new Error("GlobalHeadProvider requires a hostPlatform prop");
  }
  const { isDesktop } = typeof window !== "undefined" ? useMediaQuery$1({}) : { isDesktop: () => true };
  const isHybrid = typeof window !== "undefined" ? useInRangeMediaQuery(HYBRID_BREAKPOINTS.MIN_WIDTH, HYBRID_BREAKPOINTS.MAX_WIDTH) : false;
  const isDesktopDevice = isDesktop() || isHybrid;
  const [isAuthenticated, setIsAuthenticated] = useState(AppContextDefaults.isAuthenticated);
  const [isTierOneNavOpen, setIsTierOneNavOpen] = useState(AppContextDefaults.isTierOneNavOpen);
  const [isTierTwoNavOpen, setIsTierTwoNavOpen] = useState(AppContextDefaults.isTierTwoNavOpen);
  const [isSearchBarOpen, setIsSearchBarOpen] = useState(AppContextDefaults.isSearchBarOpen);
  const [isMyAccountMenuOpen, setIsMyAccountMenuOpen] = useState(AppContextDefaults.isMyAccountMenuOpen);
  const {
    isMenuLoading,
    menuData
  } = useFetchMenu({ environment });
  const {
    isUserDataLoading,
    userData,
    userDataError,
    setUserDataError
  } = useFetchUserData({ environment, isAuthenticated, setIsAuthenticated });
  const handleNavBarClick = (action, isOpen = false) => {
    switch (action) {
      case NAVIGATION_BAR_ACTIONS.TIER_1:
        setIsTierTwoNavOpen(false);
        setIsSearchBarOpen(false);
        setIsMyAccountMenuOpen(false);
        setIsTierOneNavOpen(isOpen);
        return;
      case NAVIGATION_BAR_ACTIONS.TIER_2:
        setIsSearchBarOpen(false);
        setIsTierOneNavOpen(false);
        setIsMyAccountMenuOpen(false);
        setIsTierTwoNavOpen(isOpen);
        return;
      default:
        setIsSearchBarOpen(false);
        setIsTierOneNavOpen(false);
        setIsTierTwoNavOpen(false);
        setIsMyAccountMenuOpen(false);
        return;
    }
  };
  const handleSearchBarClick = (isOpen = false) => {
    handleNavBarClick(NAVIGATION_BAR_ACTIONS.CLOSE_ALL);
    setIsSearchBarOpen(isOpen);
  };
  const handleMyAccountMenuClick = (isOpen = false) => {
    handleNavBarClick(NAVIGATION_BAR_ACTIONS.CLOSE_ALL);
    setIsMyAccountMenuOpen(isOpen);
  };
  const userName = (userData == null ? void 0 : userData.username) ?? "";
  const hostname = typeof window === "undefined" ? null : (_a = window == null ? void 0 : window.location) == null ? void 0 : _a.hostname;
  return /* @__PURE__ */ jsx(
    GlobalHeadContext.Provider,
    {
      value: {
        isUserDataLoading,
        userDataError,
        isMenuLoading,
        environment,
        hostname,
        hostPlatform,
        isAuthenticated,
        isDesktop: isDesktopDevice,
        isTierOneNavOpen,
        isTierTwoNavOpen,
        isSearchBarOpen,
        isMyAccountMenuOpen,
        LinkComponent,
        // @todo: Should be changed to globalNav to keep consistency with the endpoint response
        navigationLinkNodes: menuData.globalNav,
        globalAccountLinks: menuData.globalAccount,
        userName,
        handleSearchBarClick,
        handleMyAccountMenuClick,
        handleNavBarClick,
        setIsAuthenticated,
        setIsTierOneNavOpen,
        setIsTierTwoNavOpen,
        setUserDataError,
        uat
      },
      children
    }
  );
};
const GlobalHeader = ({
  environment = ENVIRONMENTS.DEVELOPMENT,
  hostPlatform = HOST_PLATFORM.GATSBY,
  LinkComponent = "a",
  uat = false,
  importCss = true
}) => {
  return /* @__PURE__ */ jsx(
    DesignSystemProvider,
    {
      appName: APP_NAMES.global_head,
      theme: { ...classes, ...components },
      shouldMergeWithBaseTheme: true,
      importCss,
      children: /* @__PURE__ */ jsx(
        GlobalHeadProvider,
        {
          environment,
          hostPlatform,
          LinkComponent,
          uat,
          children: /* @__PURE__ */ jsx(Ribbon, {})
        }
      )
    }
  );
};
export {
  GlobalHeader
};
//# sourceMappingURL=index.es.js.map
